require('@babel/polyfill');
import './lib/formdata.min.js';
import './lib/formdata.min.js';
import '../assets/scss/reset.scss';
import '../assets/scss/common.scss';
import './setFontSize';
import * as config from './config.js';
import Indicator from '../components/Indicator';
import Toast from '../components/Toast';
import * as api from '@/utils/api.js';
import Vue from 'vue';
import Store from './Store';
import $ from './myJQuery';
import report from './report';
import event from './event.js';
import action from './action.js';
import { Dialog } from 'vant';
import previewImage from '@/utils/previewImage.js';
import ClipboardJS from 'clipboard';
import slog from './slog.js';
import { logger, createLogFile, clearLogFile, getLogSize } from './logger.js';
import loadTalkData from './loadTalkData.js';
import { throttle } from 'throttle-debounce';
import './polyfill.js';
import * as constant from './constant.js';
import { getSkuBackgroundDefaultOpacity } from './sku/featureConfig.js';
import { ROUTE_NAMES } from './routeNames.js';
import {
  bajiTypeList,
  beidianTypeList,
  cardTypeList,
  colorPaperTypeList,
  crystalTypeList,
  frontBackLayer,
  isCustomSizeTypeList,
  keyTypeList,
  layerTypeList,
  lifePbTypeList,
  lifeTypeList,
  nameStickerTypeList,
  noTemplateLayerTypeList,
  pasterTypeList,
  pbTypeList,
  photoRollTypeList,
  pldSkyTypeList,
  retouchHeadTypeList,
  supportDivideUploadList,
  templateLayerTypeList
} from '@/service/skuManage.js';
import canvasUtil from './canvasUtil.js';
import { calcCrc } from './changeDpi.js';
import { cache, Cache } from './Cache.js';
import DebugLog from './debugLog.js';
import { debugGroupConsole } from './debugGroupConsole.js';
import {
  clearPageDebugLog,
  copyPageDebugLog,
  downloadPageDebugLog,
  initPageDebugLogButton,
  recordPageDebugLog
} from './pageDebugLog.js';
import {
  loadImage,
  base64ToFile,
  base64ToFileCache,
  calcMaxSize,
  blobUrlToFile,
  logTime,
  formatLogTime,
  formatFileSize,
  _getImageErrorCodeInfo
} from './lib/imageHelpers.js';
import { compressImage } from './lib/compressImage.js';
import { createFileBlobUrl, revokeBlobUrl } from './blobUrl.js';
const cachePromiseCache = new Cache(1000);
const cachePromisePendingMap = {};
// type -> Set<compositeKey>
const cachePromiseTypeIndex = {};
// normalizedCacheKey -> Set<type>
const cachePromiseCacheKeyIndex = {};
const debugLogInstance = new DebugLog({
  isPrintLog: false,
  isPrintStack: true
});
// 为了保持向后兼容，创建一个包装函数
const debugLog = function (data) {
  if (
    location.hostname != 'xingbaidesign.com' ||
    Store.getSession('debugger') == 1
  ) {
    debugLogInstance.log(data);
  }
};
window._debugLog = debugLog;
export const {
  isDev,
  isDevPrintLog,
  isShapeFillWhite,
  lastUpdateDateTime
} = config;
export { canvasUtil, config, cache, Cache };
export { _getImageErrorCodeInfo, formatLogTime, formatFileSize };
initPageDebugLogButton(isDev);

window.logger = logger;
const log = logger;
loadTalkData();

try {
  if (typeof globalThis === 'undefined') {
    window.globalThis = window;
  }
} catch (error) {}

function copyText(text) {
  let div = document.createElement('div');
  div.className = '__copy';
  document.body.appendChild(div);
  let clipboard = new ClipboardJS(div, {
    text: () => text
  });
  clipboard.on('success', (e) => {
    document.body.removeChild(div);
    // 成功回调
    e.clearSelection();
  });

  clipboard.on('error', (e) => {
    // 失败回调
  });
  div.click();
}

import VueLazyload from 'vue-lazyload';
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error:
    'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
  loading:
    'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==',
  attempt: 1
});

window.$ = $;
window.Vue = Vue;
window.report = (eventId, label, data) => {
  try {
    report(eventId, label, data);
  } catch (error) {
    console.log(error);
  }
};

const qs = require('querystringify');
Vue.prototype.$qs = qs;

//
let isDebug =
  Store.getSession('debugger') == 1 || location.href.indexOf('debug=1') > -1;

// 添加调试
if (isDebug && 0) {
  // 添加调试
  var script = document.createElement('script');
  var head = document.head || document.getElementsByTagName('head')[0];
  script.src = isDev
    ? location.origin + '/vconsole.js'
    : '//xingbaidesign.com/vconsole.js';
  head.appendChild(script);
  Vue.config.devtools = true;
  setTimeout(() => {
    window.VConsole && new window.VConsole();
  }, 3000);
  Store.setSession('debugger', 1);
}

function errorHandler(ex) {
  try {
    slog.error(ex);
  } catch (error) {}
}
if (!isDev) {
  window.__bl = () => {};
  window.addEventListener('error', errorHandler);
  window.addEventListener('unhandledrejection', errorHandler);
}
Vue.config.errorHandler = function (err, vm, info) {
  errorHandler(err);
};

if (!window.innerWidth) {
  window.innerWidth =
    document.documentElement.clientWidth || document.body.clientWidth;
  window.innerHeight =
    document.documentElement.clientHeight || document.body.clientHeight;
}

let isWeb = typeof getApp === 'undefined';
Vue.prototype.setData = function (data) {
  for (let key in data) {
    this[key] = data[key];
  }
};
Vue.prototype.getData = function () {
  if (isWeb) {
    return this;
  } else {
    return this.data;
  }
};
Vue.prototype.setKey = function (key, val) {};

function setTitle(title) {
  document.title = title;
  if (/iphone|ipad|ipod/.test(navigator.userAgent.toLowerCase())) {
    var i = document.createElement('iframe');
    i.src = '//xingbaidesign.com/favicon.ico';
    i.style.display = 'none';
    i.onload = function () {
      setTimeout(() => {
        i.remove();
      }, 0);
    };
    document.body.appendChild(i);
  }
}

function stopScroll(selector) {
  console.log(
    'document.querySelector(selector)',
    document.querySelector(selector)
  );
  document.querySelector(selector).addEventListener(
    'touchmove',
    (e) => {
      e.preventDefault();
    },
    { passive: false }
  );
}

function delay(milliseconds) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve();
    }, milliseconds);
  });
}

/**
 * 功能说明：获取 pollCheck 统计使用的当前时间。
 * @returns {number} 当前时间戳，单位毫秒
 */
function getPollCheckPerfNow() {
  // 浏览器支持 performance.now 时优先使用高精度时间。
  if (
    typeof performance !== 'undefined' &&
    performance &&
    typeof performance.now === 'function'
  ) {
    return performance.now();
  }
  return Date.now();
}

/**
 * 功能说明：把 pollCheck 单次执行结果上报到性能统计模块。
 * @param {Object} payload - pollCheck 单次统计信息
 * @returns {void} 无返回值
 */
function recordPollCheckPerf(payload) {
  // 未启用性能统计注入时不记录 pollCheck，避免影响正常环境。
  if (
    typeof window === 'undefined' ||
    typeof window.__perfRecordPollCheck !== 'function'
  ) {
    return;
  }
  window.__perfRecordPollCheck(payload);
}

function pollCheck(fn, ms = 100, timeout = 5000) {
  const start = getPollCheckPerfNow();
  let checkCount = 0;
  let timeoutError = new Error(`pollCheck timeout: ${timeout}ms`);
  // 支持捕获调用 pollCheck 时的调用栈，避免异步超时回调丢失调用来源
  if (Error.captureStackTrace) {
    Error.captureStackTrace(timeoutError, pollCheck);
  }
  let timer;
  let pro = new Promise((resolve, reject) => {
    let r;
    try {
      checkCount++;
      r = fn();
      if (r) {
        recordPollCheckPerf({
          status: 'resolved',
          cost: getPollCheckPerfNow() - start,
          checks: checkCount,
          ms,
          timeout,
          stack: timeoutError.stack
        });
        resolve(r);
        return;
      }
    } catch (error) {
      recordPollCheckPerf({
        status: 'error',
        cost: getPollCheckPerfNow() - start,
        checks: checkCount,
        ms,
        timeout,
        stack: timeoutError.stack,
        message: error && error.message
      });
      reject(error);
      return;
    }
    let timer1 = setTimeout(() => {
      clearInterval(timer);
      timer = null;
      clearTimeout(timer1);
      timer1 = null;
      recordPollCheckPerf({
        status: 'timeout',
        cost: getPollCheckPerfNow() - start,
        checks: checkCount,
        ms,
        timeout,
        stack: timeoutError.stack,
        message: timeoutError.message
      });
      reject(timeoutError);
      console.error('pollCheck timeout', timeoutError, fn);
    }, timeout);
    timer = setInterval(() => {
      if (isDevPrintLog) {
        console.log('pollCheck', fn);
      }
      try {
        checkCount++;
        let r = fn();
        if (r) {
          recordPollCheckPerf({
            status: 'resolved',
            cost: getPollCheckPerfNow() - start,
            checks: checkCount,
            ms,
            timeout,
            stack: timeoutError.stack
          });
          resolve(r);
          clearInterval(timer);
          timer = null;
          clearTimeout(timer1);
          timer1 = null;
        }
      } catch (error) {
        recordPollCheckPerf({
          status: 'error',
          cost: getPollCheckPerfNow() - start,
          checks: checkCount,
          ms,
          timeout,
          stack: timeoutError.stack,
          message: error && error.message
        });
        reject(error);
        clearInterval(timer);
        timer = null;
        clearTimeout(timer1);
        timer1 = null;
      }
    }, ms);
  });
  pro.__timer = timer;
  return pro;
}

/**
 * 防止重复点击,在func执行完成之后才可以再次执行func
 * @param {Function} func 被包装的函数
 * @param {boolean} [manual=false] 是否手动解锁,默认为false,会在func函数resolve之后自动进行解锁。
 * @param {number} [maxMs=0] 最长锁定时间(毫秒);大于0时,超时后自动解锁,与manual调用done或Promise.finally解锁等价
 * @returns {Function} 包装后的函数;锁定期间重复调用会直接return undefined
 */
function ignoreMultiClick(func, manual = false, maxMs = 0) {
  let lock = false;
  return function (...args) {
    if (lock) return;
    lock = true;
    let timerId = null;
    let finished = false;
    let done = function () {
      if (finished) return;
      finished = true;
      if (timerId !== null) {
        clearTimeout(timerId);
        timerId = null;
      }
      lock = false;
    };
    if (typeof maxMs === 'number' && maxMs > 0) {
      timerId = setTimeout(done, maxMs);
    }
    if (manual) return func.call(this, ...args, done);
    let promise = func.call(this, ...args);
    Promise.resolve(promise).finally(done); // func可以不返回Promise对象
    return promise;
  };
}

/**
 * 防止入口在执行期间或短时间内重复触发。
 * @param {Function} func 被包装的函数。
 * @param {number} [minMs=1000] 每次触发后的最短锁定时间，单位毫秒。
 * @param {number} [maxLockMs=5000] 单次触发的最长锁定时间，单位毫秒。
 * @returns {Function} 包装后的函数，锁定期间重复调用会直接返回 undefined。
 */
function ignoreRepeatedTrigger(func, minMs = 1000, maxLockMs = 5000) {
  let lock = false;
  let lastTriggerTime = 0;
  let unlockByPageLeave = null;
  return function (...args) {
    // 当前入口正在执行时，忽略重复触发。
    if (lock) {
      return;
    }
    const now = Date.now();
    // 距离上次触发未超过最短锁定时间时，忽略重复触发。
    if (now - lastTriggerTime < minMs) {
      return;
    }
    lock = true;
    lastTriggerTime = now;
    let minTimer = null;
    let maxTimer = null;
    let minTimePassed = false;
    let taskFinished = false;
    let released = false;
    /**
     * 清理当前触发入口的解锁定时器。
     * @returns {void}
     */
    const clearUnlockTimers = () => {
      // 最短锁定定时器存在时，释放前需要清理。
      if (minTimer) {
        clearTimeout(minTimer);
        minTimer = null;
      }
      // 最长锁定定时器存在时，释放前需要清理。
      if (maxTimer) {
        clearTimeout(maxTimer);
        maxTimer = null;
      }
    };
    /**
     * 释放当前触发入口锁。
     * @param {Object} [opt] 解锁选项。
     * @param {boolean} [opt.resetTriggerTime=false] 是否重置最近触发时间。
     * @returns {void}
     */
    const releaseLock = (opt = {}) => {
      // 已释放过的入口不重复处理，避免旧异步回调影响后续触发。
      if (released) {
        return;
      }
      released = true;
      lock = false;
      // 页面离开时重置触发时间，避免重新进入页面仍受 1 秒间隔影响。
      if (opt.resetTriggerTime) {
        lastTriggerTime = 0;
      }
      clearUnlockTimers();
      // 已绑定页面生命周期时，解锁后同步解除监听。
      if (unlockByPageLeave) {
        unlockByPageLeave();
        unlockByPageLeave = null;
      }
    };
    unlockByPageLeave = bindIgnoreRepeatedTriggerPageLeave(this, () => {
      releaseLock({ resetTriggerTime: true });
    });
    minTimer = setTimeout(() => {
      minTimePassed = true;
      // 业务流程已结束时，满足最短锁定时间后释放。
      if (taskFinished) {
        releaseLock();
      }
    }, minMs);
    maxTimer = setTimeout(() => {
      releaseLock();
    }, Math.max(minMs, maxLockMs));
    let promise;
    try {
      promise = func.call(this, ...args);
    } catch (error) {
      releaseLock({ resetTriggerTime: true });
      throw error;
    }
    Promise.resolve(promise).then(
      () => {
        taskFinished = true;
        // 已满足最短锁定时间时，业务流程结束后立即释放。
        if (minTimePassed) {
          releaseLock();
        }
      },
      () => {
        taskFinished = true;
        // 已满足最短锁定时间时，业务流程异常后立即释放。
        if (minTimePassed) {
          releaseLock();
        }
      }
    );
    return promise;
  };
}

/**
 * 监听页面离开并释放防重复触发锁。
 * @param {Object} vm Vue 页面实例。
 * @param {Function} unlock 页面离开时执行的解锁回调。
 * @returns {Function|null} 解除页面离开监听的函数。
 */
function bindIgnoreRepeatedTriggerPageLeave(vm, unlock) {
  // 非 Vue 实例或无事件能力时，不绑定页面生命周期。
  if (!vm || typeof vm.$once !== 'function') {
    return null;
  }
  const hookList = ['hook:beforeDestroy', 'hook:deactivated'];
  const unbindList = [];
  hookList.forEach((hookName) => {
    const handler = () => {
      unlock();
    };
    vm.$once(hookName, handler);
    // Vue 实例支持 $off 时，解锁后移除未触发的生命周期监听。
    if (typeof vm.$off === 'function') {
      unbindList.push(() => {
        vm.$off(hookName, handler);
      });
    }
  });
  return () => {
    unbindList.forEach((unbind) => {
      unbind();
    });
  };
}

let fileToBase64Cache = {};

// 从File对象读取文件并转换为Base64编码
function fileToBase64(file, opt = { noCache: true }) {
  let cacheKey = JSON.stringify({
    name: file.name,
    size: file.size,
    type: file.type,
    lastModified: file.lastModified
  });

  if (fileToBase64Cache[cacheKey] && !opt.noCache) {
    return Promise.resolve(fileToBase64Cache[cacheKey]);
  }

  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = function (event) {
      const base64String = event.target.result;
      resolve(base64String);
      if (!opt.noCache) {
        fileToBase64Cache[cacheKey] = base64String;
        base64ToFileCache[base64String.slice(-100, base64String.length)] = file;
      }
      reader = null;
    };
    reader.onerror = function (error) {
      slog.log('fileToBase64 error', error);
      reject(error);
      reader = null;
    };
    reader.readAsDataURL(file);
  });
}

function parseIntPrice(v) {
  if (v == parseInt(v)) {
    return parseInt(v);
  } else {
    return v;
  }
}

function calcCenterSize(width, height, maxWidth, maxHeight) {
  let ratio = width / height;
  let w;
  let h;
  if (ratio > maxWidth / maxHeight) {
    h = maxHeight;
    w = h * ratio;
  } else {
    w = maxWidth;
    h = w / ratio;
  }
  return {
    width: w,
    height: h
  };
}

function getSideLength(p1, p2) {
  return Math.sqrt(Math.pow(p1.x - p2.x, 2) + Math.pow(p1.y - p2.y, 2));
}
function getAngleFromThreeSideLength(a, b, c) {
  return (Math.acos((c * c - a * a - b * b) / -2 / a / b) * 180) / Math.PI;
}

function timeout(pro, time) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      reject(timeout);
    }, time);
    pro.then((r) => {
      resolve(r);
    });
  });
}

async function repeatPromise({ promiseCb, repeatCount = 1, repeatInterval }) {
  let count = 0;
  let result;
  while (count < repeatCount) {
    try {
      result = await promiseCb(count);
      return result;
    } catch (error) {
      count++;
      if (count == repeatCount) {
        throw error;
      }
      slog.log('\nrepeatPromise:', repeatCount);
      await delay(repeatInterval);
    }
  }
}

function _getImageInfo(imageUrl) {
  let startTime = Date.now();
  let loadError = new Error(`_getImageInfo load fail: ${imageUrl}`);
  // 支持捕获调用 _getImageInfo 时的调用栈，避免图片异步加载失败后丢失调用来源
  if (Error.captureStackTrace) {
    Error.captureStackTrace(loadError, _getImageInfo);
  }
  if (!imageUrl && isDev) {
    debugger;
  }
  if (!imageUrl) {
    report('error', { reason: '_getImageInfo imageUrl is null' });
    try {
      throw new Error('imageUrl is null');
    } catch (error) {
      report('util_error', {
        msg: `stack:${error && error.stack},msg=${error && error.message}`
      });
      // console.error(error);
      // 处理错误
    }
  }
  if (imageUrl == 'data:,') {
    report('error', { reason: '_getImageInfo imageUrl is data:,' });
  }
  return new Promise((resolve, reject) => {
    let img = new Image();
    if (/http/.test(imageUrl)) {
      img.crossOrigin = 'anonymous';
    }
    img.onload = () => {
      if (img.naturalWidth) {
        img.width = img.naturalWidth;
        img.height = img.naturalHeight;
      }
      resolve(img);
      // logTime(`_getImageInfo耗时`, new Date() - startTime + 'ms');
    };
    img.onerror = (err) => {
      _getImageErrorCodeInfo(imageUrl);
      loadError.event = err;
      reject(loadError);
    };
    img.src = imageUrl;
  });
}
export function isEmpty(v) {
  return (
    v === null ||
    v === undefined ||
    v === '' ||
    v === 'null' ||
    v === 'undefined'
  );
}
export function addParams(url, params) {
  const queryString = Object.keys(params)
    .map(
      (key) =>
        `${key}=${encodeURIComponent(isEmpty(params[key]) ? '' : params[key])}`
    )
    .join('&');
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}${queryString}`;
}

let imageInfoCacheList = [];
let maxCacheCount = 30;
function getImageInfo(imageUrl, repeatCount = 5, disableCache = false) {
  let cache = imageInfoCacheList.filter((v) => v.imageUrl === imageUrl)[0];
  if (cache && !disableCache) {
    return Promise.resolve(cache.data);
  }
  return repeatPromise({
    promiseCb: () => _getImageInfo(imageUrl),
    repeatCount,
    repeatInterval: 1000
  })
    .then((r) => {
      imageInfoCacheList.push({
        imageUrl,
        data: r
      });
      if (imageInfoCacheList.length > maxCacheCount) {
        imageInfoCacheList.shift();
      }
      return r;
    })
    .catch((r) => {
      let message = String(r);
      slog.error(
        `getImageInfo repeat fail:imageSrc=${imageUrl},error:` + message
      );
      // report('getImageInfoFail', {
      //   msg: `${message}, imageSrc=${imageUrl ? imageUrl.slice(0, 100) : ''}`
      // });
      throw r;
    });
}

function getBase64MimeType(base64String) {
  // 使用正则表达式匹配data URI格式的头部信息
  const matches = base64String.match(/^data:(.*?);base64,/);

  // 如果匹配成功且有MIME类型，则返回MIME类型
  if (matches && matches[1]) {
    return matches[1];
  }

  // 如果没有匹配成功，则返回null或者适当的默认值
  return null;
}

export function createImage(imageSrc) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'anonymous';
    img.onload = () => {
      resolve(img);
    };
    img.onerror = (err) => {
      reject(err);
    };
    img.src = imageSrc;
  });
}

async function useCompressImage({
  imageSrc,
  maxWidth,
  maxHeight,
  imageType = 'image/jpeg',
  specifiedWidth,
  specifiedHeight
}) {
  let canvas = document.createElement('canvas');
  let ctx = canvas.getContext('2d');
  let mimeType = imageType;
  let imageInfo = await getImageInfo(imageSrc);
  let width = imageInfo.width;
  let height = imageInfo.height;

  if (width > specifiedWidth && height > specifiedHeight) {
    width = specifiedWidth;
    height = specifiedHeight;
  } else if (width > maxWidth || height > maxHeight) {
    const ratio = Math.min(maxWidth / width, maxHeight / height);
    width = Math.round(width * ratio);
    height = Math.round(height * ratio);
  }

  canvas.width = width;
  canvas.height = height;

  let img = await createImage(imageSrc);

  // 在canvas上绘制压缩后的图片
  ctx.drawImage(img, 0, 0, width, height);

  // 将canvas转换为DataURL格式
  let quality = 1;
  if (imageSrc.length / 1024 / 1024 > 10) {
    quality = 0.92;
  }

  let compressedDataURL = canvas.toDataURL(mimeType, quality); // 或 'image/png'，取决于你的需求
  if (compressedDataURL == 'data:,') {
    slog.log(
      `compressedDataURL data fail,width=${width},height=${height},specifiedWidth=${specifiedWidth},specifiedHeight=${specifiedHeight}`
    );
    return imageSrc;
  }
  // slog.log(
  //   `压缩前=${parseInt(imageSrc.length / 1024 / 1024)}mb,压缩后=${parseInt(
  //     compressedDataURL.length / 1024 / 1024
  //   )}mb`
  // );
  // downloadFile(compressedDataURL);
  // 显示压缩后的图片
  canvas = null;
  ctx = null;
  return compressedDataURL;
}

function downloadFile(imgDataUrl, filename = 'image.png') {
  // 跨域URL需要先转为同源blob URL，否则download属性不生效
  if (/^https?:\/\//.test(imgDataUrl)) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', imgDataUrl, true);
    xhr.responseType = 'blob';
    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        var blob = xhr.response;
        var blobUrl = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = blobUrl;
        a.download = filename;
        a.click();
        URL.revokeObjectURL(blobUrl);
      }
    };
    xhr.send();
    return;
  }
  var a = document.createElement('a');
  a.href = imgDataUrl;
  a.download = filename;
  a.click();
}

function showLoading(text, opt) {
  if (typeof opt != 'object') {
    opt = {};
  }
  Indicator.open(text || '加载中...', opt);
  // console.log('----show');
}
function hideLoading(delay) {
  if (delay) {
    setTimeout(() => {
      // console.log('----hide', delay);
      Indicator.close();
    }, delay);
  } else {
    Indicator.close();
    // console.log('----hide');
  }
}

async function checkImageRisk(img, opt = {}) {
  let info = await api.checkImage(img, opt);
  // info.checkStatus = -1;
  if (info.checkStatus == -1) {
    Toast('检测到有图片存在违规内容', false, 4000);
    throw new Error('检测到有图片存在违规内容');
  } else if (info.checkStatus == -2) {
    if (info.statusCode == 413) {
      Toast('图片大小超过限制', false, 4000);
      throw new Error('图片大小超过限制');
    } else {
      Toast('图片上传超时,请重新上传', false, 4000);
      throw new Error('图片上传超时,请重新上传');
    }
  }
  return info;
}

function getApp() {
  return {
    globalData: {
      px2rpx: 2,
      setting: {
        useLocalCrop: true
      }
    }
  };
}

function confirmModal(opt) {
  if (opt.showCancelButton === undefined) {
    opt.showCancelButton = true;
  }
  return Dialog.confirm({
    title: '',
    message: opt.content,
    confirmButtonText: opt.confirmText,
    cancelButtonText: opt.cancelText,
    confirmButtonColor: '#576B95',
    showCancelButton:
      opt.showCancel !== undefined ? opt.showCancel : opt.showCancelButton,
    closeOnPopstate: false
  })
    .then((r) => {
      return 1;
    })
    .catch((err) => {
      return -1;
    });
}

function getImgFileSize(file) {
  return new Promise((resolve, reject) => {
    // 创建一个 Image 对象
    const img = new Image();

    // 设置 Image 对象的 src 属性为选择的图片文件的URL
    img.src = URL.createObjectURL(file);

    // 等待图片加载完成
    img.onload = function () {
      // 获取图片的宽度和高度
      resolve(img);
      // slog.log('getImgFileSize', file, img.width, img.height);
    };
    img.onerror = function (err) {
      reject(err);
    };
  });
}

/**
 * 传入一个函数队列，每个函数函数执行回返回一个Promise。同时只能有max个promise在执行，所有promise执行完毕后返回一个promise
 * @param {Array} returnPromiseCallbackList 数组中的每一项都是一个函数，函数返回一个promise
 * @param {number} [max=1] promise的最大并发数
 * @returns Promise 所有promise执行完毕后promise
 */
function limitConcurrency(returnPromiseCallbackList, max = 1) {
  return new Promise((resolve) => {
    let index = 0;
    let running = 0;
    let results = [];
    if (!returnPromiseCallbackList.length) {
      resolve(results);
      return;
    }

    function run() {
      while (running < max && index < returnPromiseCallbackList.length) {
        running++;
        const currentIndex = index;
        const promise = returnPromiseCallbackList[index]();
        index++;
        promise
          .then((result) => {
            results[currentIndex] = result;
          })
          .finally(() => {
            running--;
            if (index === returnPromiseCallbackList.length && running === 0) {
              resolve(results);
            } else {
              run();
            }
          });
      }
    }
    run();
  });
}

/**
 * 创建指定长度的随机字符串
 * @param {Number} length
 * @returns
 */
function createId(length) {
  let result = '';
  let characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}

function removeUnUseStorage() {
  slog.log('--removeUnUseStorage--');
  let keys = [
    'highOriginConfig',
    'cardImage',
    'sixCardImage',
    'singleCardCreateInfo',
    'PrevCreateInfo'
  ];
  keys.forEach((key) => {
    Store.remove(key);
  });
}

// 获取纸张的px信息
// 注： 返回的width始终是大于height的，但实际预览和编辑视图中进行了旋转，width是小于height的
function getPhotoSizeInfo(info) {
  let newW = Math.round((info.paperWidth / 25.4) * 300);
  let newH = Math.round((info.paperHeight / 25.4) * 300);
  return {
    width: newW,
    height: newH,
    ratio: info.paperWidth / info.paperHeight
  };

  // 六寸为基准
  // 六寸尺寸15.2cm*10.2cm   6=15.2/2.54
  // 5寸尺寸 12.7cm*8.9cm    5=12.7/2.54
  // 3寸尺寸 5.5cm*8.4cm    3=12.7/2.54
  // 57/25.4*300
  // let w = 1793;
  // let h = 1203;
  // let width;
  // let height;
  // // info.inch = 6;
  // if (info.inch == 6) {
  //   width = w;
  //   height = h;
  //   return {
  //     width,
  //     height
  //   };
  // } else if (info.inch == 5) {
  //   width = Math.round((12.7 / 15.2) * w);
  //   height = Math.round((8.9 / 10.2) * h);
  //   return {
  //     width,
  //     height
  //   };
  // } else {
  //   let newW = Math.round((info.paperWidth / 25.4) * 300);
  //   let newH = Math.round((info.paperHeight / 25.4) * 300);
  //   if (newW < newH) {
  //     return {
  //       width: newH,
  //       height: newW
  //     };
  //   } else {
  //     return {
  //       width: newW,
  //       height: newH
  //     };
  //   }
  // }
}

function isOnlineImage(imageSrc) {
  return /^http/.test(imageSrc);
}

function getImgErrorCode(imgSrc) {
  if (!imgSrc) {
    if (!window._isFirstDebugger) {
      window._isFirstDebugger = true;
    }
    slog.error('getImgErrorCode imgSrc is null');
    return;
  }
  var img = new Image();
  img.src = imgSrc;
  return new Promise((resolve, reject) => {
    img.onload = () => {
      slog.log('getImgErrorCode success', imgSrc);
    };
    img.onerror = function () {
      var xhr = new XMLHttpRequest();
      xhr.open('GET', imgSrc, true);
      xhr.onload = function () {
        // 获取HTTP状态码
        var status = xhr.status;
        slog.log(
          `图片加载失败=${
            imgSrc ? imgSrc.slice(0, 100) : ''
          }\n,状态码: ${status}`
        );
        resolve(status);
        // 处理其他相关操作
      };
      xhr.onerror = function (err) {
        slog.log(`图片加载失败=${imgSrc ? imgSrc.slice(0, 100) : ''}\n`);
        slog.error(err);
      };
      xhr.send();
    };
  });
}

function isPC() {
  'use strict';
  // 1. 获取视口宽度（当前可视区域，实时更新）和UA（转小写避免大小写问题）
  const viewWidth = window.innerWidth;
  const userAgent = navigator.userAgent.toLowerCase();
  // 2. 完整移动端UA关键词库（覆盖手机、平板、鸿蒙、微信、小程序等）
  const mobileAgents = [
    'android',
    'iphone',
    'symbianos',
    'windows phone',
    'ipad',
    'ipod',
    'harmonyos',
    'micromessenger',
    'huawei-mediapad',
    'mi-pad',
    'pad',
    'mobile'
  ];

  // 双判断逻辑：
  // ① 只要UA包含移动端关键词 → 判定为非PC端
  // ② UA无匹配时，视口宽度≤768px → 非PC端；＞768px → PC端
  for (const agent of mobileAgents) {
    if (userAgent.indexOf(agent) !== -1) {
      return false;
    }
  }
  return viewWidth > 768;
}

function convertCropInfo(data, type, opt = {}) {
  function fixed(num, fix = 0) {
    if (fix) {
      return parseFloat(num.toFixed(fix));
    } else {
      return parseInt(num || 0);
    }
  }
  // 前端数据结构转换为后台结构
  if (type == 'toServer') {
    let x = fixed(data.imageInfo.x, 2);
    let y = fixed(data.imageInfo.y, 2);
    let w = fixed(data.imageInfo.width, 2);
    let h = fixed(data.imageInfo.height, 2);
    let width = fixed(data.canvasWidth, 2);
    let height = fixed(data.canvasHeight, 2);
    if (data.layoutType == 'fill') {
      // 填充模式  图片的一边和内框的一边对齐
      let diffW = Math.abs(w - width);
      let diffH = Math.abs(h - height);
      // fix: 1px误差
      if (diffW < diffH) {
        // 宽度对齐
        if (diffW <= 1) {
          w = width;
          x = 0;
        }
      } else {
        // 长度对齐
        if (diffH <= 1) {
          h = height;
          y = 0;
        }
      }
    }
    // 修复小数误差
    if (data.layoutType == 'fit') {
      let x1 = (width - w) / 2;
      let y1 = (height - h) / 2;
      if (y == 0 && Math.abs(x - x1) <= 1) {
        x = Number(x1.toFixed(1));
      } else if (x == 0 && Math.abs(y - y1) <= 1) {
        y = Number(y1.toFixed(1));
      }
      if (Math.abs(width - w) <= 1) {
        w = width;
      }
      if (Math.abs(height - h) <= 1) {
        h = height;
      }
    }
    let result = {
      layout: data.layoutType == 'fit' ? 'fit' : 'fill',
      border: fixed(data.whiteBorder),
      x,
      y,
      w,
      h,
      width,
      height,
      mode: data.mode || 0
    };
    if (data.paperWidth) {
      result.paperWidth = data.paperWidth;
      result.paperHeight = data.paperHeight;
    }
    return result;
  } else {
    return {
      paperWidth: data.paperWidth || 0,
      paperHeight: data.paperHeight || 0,
      layoutType: data.layout, // 填充方式
      whiteBorder: data.border, // 是否有白边
      imageInfo: {
        // 图片在内框的位置和大小
        x: data.x,
        y: data.y,
        width: data.w,
        height: data.h
      },
      canvasWidth: data.width, // 拍立得内框的宽高（不包含边框）
      canvasHeight: data.height,
      mode: data.mode || 0 // 用户是否修改过   0：默认  1：移动 2：旋转
    };
  }
}

function fileToBlobUrl(file) {
  // slog.log('fileToBlobUrl before');
  let r = createFileBlobUrl(file);
  // slog.log(`fileToBlobUrl after:isFile=${file instanceof File},url=${r}`);
  return r;
}

function getFileFromBlobUrl(blobUrl) {
  try {
    if (!window.__fileUrlMap[blobUrl]) {
      slog.log('getFileFromBlobUrl fail', blobUrl);
    }
    return window.__fileUrlMap[blobUrl];
  } catch (error) {
    return '';
  }
}

export function base64ToBlobUrl(base64Data) {
  // 分离 MIME 类型和纯 Base64 数据
  const parts = base64Data.split(';base64,');
  const contentType = parts[0].split(':')[1] || 'image/png';
  const raw = window.atob(parts[1]);

  // 转换为 Uint8Array
  const byteArray = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) {
    byteArray[i] = raw.charCodeAt(i);
  }

  // 生成 Blob 和 URL
  const blob = new Blob([byteArray], { type: contentType });
  return URL.createObjectURL(blob);
}

const failReasonMap = {
  rotateFail: '当前图片格式暂不支持',
  minifyFail: '当前图片格式暂不支持',
  imageRisk: '图片存在违规内容',
  uploadFail: '图片上传失败',
  convertFail: '图片格式转换失败',
  fileToUrlFail: '当前图片格式暂不支持',
  imageTypeError: '当前图片格式暂不支持',
  getImageInfoFail: '获取图片信息失败',
  createImageFail: '当前图片格式暂不支持',
  imageRatioFail: '检测到当前图片数据异常',
  imageRetouchFail: '当前图片超过抠图限制',
  apiFail: '接口服务异常，请重试'
};

function getFailInfo(key) {
  let error = key;
  try {
    log.error(error);
    if (!window.__uploadLog__) {
      log.info('-------主动上报--------');
      uploadLogFile(true, Math.random() > 0.5 ? 1 : 0);
      window.__uploadLog__ = true;
    }
  } catch (error) {
    console.error(error);
    // 处理错误
  }
  if (key && key.failReason && key.failResolve) {
    return key;
  }
  if (key && key.message) {
    key = key.message;
  }
  report('util_getFailInfo', { key });

  let defaultInfo = {
    failReason: '当前图片格式暂不支持',
    failResolve: '请删除后选择其他图片'
  };
  let failList = [
    {
      failReason: failReasonMap.rotateFail,
      failResolve: '请手动旋转图片后再上传'
    },
    {
      failReason: failReasonMap.minifyFail,
      failResolve: '请删除后重试或更换图片'
    },
    {
      failReason: failReasonMap.imageRisk,
      failResolve: '请更换图片后再上传'
    },
    {
      failReason: failReasonMap.uploadFail,
      failResolve: '请删除后重试或更换图片'
    },
    {
      failReason: failReasonMap.convertFail,
      failResolve: '请删除后重试或更换图片'
    },
    {
      failReason: failReasonMap.fileToUrlFail,
      failResolve: '请删除后更换图片'
    },
    {
      failReason: failReasonMap.getImageInfoFail,
      failResolve: '请删除后重试或更换图片'
    },
    {
      failReason: failReasonMap.createImageFail,
      failResolve: '请删除后更换图片'
    },
    {
      failReason: failReasonMap.imageTypeError,
      failResolve: '请删除后更换图片'
    },
    {
      failReason: failReasonMap.imageRatioFail,
      failResolve: '请重新上传图片'
    },
    {
      failReason: failReasonMap.imageRetouchFail,
      failResolve: '请更换图片'
    },
    {
      failReason: failReasonMap.apiFail,
      failResolve: '请检查网络后重试'
    }
  ];
  let ind = failList.findIndex((v) => v.failReason == key);
  return ind == -1 ? defaultInfo : failList[ind];
}

function getFailInfoByError(error) {
  // 接口报错（响应对象带 requestId）统一按网络异常处理，避免误报为图片处理失败
  if (
    error &&
    (error.requestId ||
      typeof error.code == 'string' ||
      typeof error.code == 'number')
  ) {
    return getFailInfo(failReasonMap.apiFail);
  }
  return getFailInfo(error);
}

function errorToString(err) {
  try {
    if (err instanceof Error) {
      // window._Sentry && window._Sentry.captureException(err);
    }
  } catch (error) {
    slog.error(error);
    // 处理错误
  }
  isDev && slog.error(err);
  let str = '';
  if (err && err.message) {
    str += err.message || err;
    if (err.stack) {
      str += '\n' + err.stack;
    }
    return str;
  } else {
    return err;
  }
}
const dcraw = require('dcraw');
function convertRawCameraImage(file) {
  return new Promise((resolve, reject) => {
    var reader = new FileReader();
    reader.onload = (function (o) {
      return function (e) {
        // Get the image file as a buffer
        var buf = new Uint8Array(e.currentTarget.result);

        // Extract the thumbnail
        var thumbnail = dcraw(buf, { extractThumbnail: true });
        // Create thumbnail
        var blob = new Blob([thumbnail], { type: 'image/jpeg' });
        var file = new Blob([blob], { type: 'image/jpeg' });
        resolve(file);
      };
    })(file);
    reader.onerror = function (e) {
      reject(e);
    };
    reader.readAsArrayBuffer(file);
  });
}

function getDomDetail(selector) {
  return document.querySelector(selector).getBoundingClientRect();
}

function saveImage(dataURL) {
  // 创建一个a元素
  var link = document.createElement('a');
  link.href = dataURL;
  link.download = 'image.png';

  // 模拟点击下载链接
  link.click();
}

let isPc = isPC();

function polyfillForPcTouches(e) {
  try {
    if (isPc || !e.touches || !e.touches.length) {
      e.touches = [{ pageX: e.pageX, pageY: e.pageY }];
    }
  } catch (error) {
    console.error(error);
    // 处理错误
  }
  return e;
}

window.globalData = {};

function isWebPSupportedWithImage() {
  return new Promise((resolve, reject) => {
    var img = new Image();
    img.onload = function () {
      // 图片加载成功且宽高非零则表示支持WebP
      if (img.width !== 0 && img.height !== 0) {
        // slog.log('Browser supports WebP.');
        resolve(1);
        return true;
      } else {
        resolve(-1);
        slog.log('Could not properly load the image, might not support WebP.');
        return false;
      }
    };
    img.onerror = function () {
      // 加载失败，通常表示不支持WebP格式
      slog.log('Browser does not support WebP.');
      resolve(-1);
      return false;
    };

    // 使用一个已知的WebP图片URL
    img.src =
      'data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=';
  });
}
let isSupprtWebp = true;
isWebPSupportedWithImage().catch((r) => {
  isSupprtWebp = false;
});

function webpToJpg(imageSrc) {
  return new Promise((resolve, reject) => {
    var image = new Image();

    image.onload = function () {
      var canvas = document.createElement('canvas');
      canvas.width = this.naturalWidth;
      canvas.height = this.naturalHeight;
      canvas.getContext('2d').drawImage(this, 0, 0);
      let r = canvas.toDataURL('image/jpeg');
      resolve(r);
    };
    image.onerror = function (err) {
      reject(err);
    };
    image.src = imageSrc;
  });
}

function setClipBoard({ text }) {
  return new Promise((resolve, reject) => {
    import(/* webpackChunkName: "clipboard" */ 'clipboard').then((v) => {
      let div = document.createElement('div');
      div.className = '__copy';
      let ClipboardJS = v.default;
      let clipboard = new ClipboardJS(div, {
        text: () => text
      });
      clipboard.on('success', (e) => {
        // 成功回调
        e.clearSelection();
        resolve();
      });

      clipboard.on('error', (e) => {
        reject();
      });
      div.click();
    });
  });
}

function getPhotoStoreKey(query) {
  let wxData = getWxData() || {};
  let key = `soId=${query.soId}&outerOiId=${query.outerOiId}&lifeSubIndex=${
    query.lifeSubIndex
  }&wxData=${JSON.stringify({
    uid: wxData.uid,
    itemId: wxData.itemId,
    skuId: wxData.skuId,
    gcId: wxData.gcId,
    orderNo: wxData.orderNo
  })}`;
  return key;
}

// photoListData 每个 key 24 小时有效期（读/写都会顺延）
const PHOTO_LIST_DATA_STORE_KEY = 'photoListData';
const PHOTO_LIST_DATA_EXPIRE_STORE_KEY = 'photoListDataExpireAt';
const TEMP_PHOTO_LIST_DATA_STORE_KEY = 'tempPhotoListData';
const TEMP_PHOTO_LIST_DATA_EXPIRE_STORE_KEY = 'tempPhotoListDataExpireAt';
const PHOTO_LIST_DATA_TTL_MS = 24 * 60 * 60 * 1000;

function getPhotoListDataWithTTL(now) {
  let data = Store.get(PHOTO_LIST_DATA_STORE_KEY) || {};
  let expireMap = Store.get(PHOTO_LIST_DATA_EXPIRE_STORE_KEY) || {};

  // 兜底：确保都是对象
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    data = {};
  }
  if (!expireMap || typeof expireMap !== 'object' || Array.isArray(expireMap)) {
    expireMap = {};
  }

  let changedData = false;
  let changedExpire = false;

  // 清理过期 key + 清理孤儿过期信息
  for (let k in expireMap) {
    if (!Object.prototype.hasOwnProperty.call(expireMap, k)) {
      continue;
    }
    let expireAt = expireMap[k];
    if (typeof expireAt !== 'number') {
      delete expireMap[k];
      changedExpire = true;
      continue;
    }

    if (expireAt <= now) {
      if (Object.prototype.hasOwnProperty.call(data, k)) {
        delete data[k];
        changedData = true;
      }
      delete expireMap[k];
      changedExpire = true;
      continue;
    }

    // data 中不存在的 key，不需要保留 expire 信息
    if (!Object.prototype.hasOwnProperty.call(data, k)) {
      delete expireMap[k];
      changedExpire = true;
    }
  }

  // 初始化：data 中存在但缺少 expireAt 的 key，补一个有效期
  for (let k in data) {
    if (!Object.prototype.hasOwnProperty.call(data, k)) {
      continue;
    }
    if (!Object.prototype.hasOwnProperty.call(expireMap, k)) {
      expireMap[k] = now + PHOTO_LIST_DATA_TTL_MS;
      changedExpire = true;
    }
  }

  if (changedData) {
    Store.set(PHOTO_LIST_DATA_STORE_KEY, data);
  }
  if (changedExpire) {
    Store.set(PHOTO_LIST_DATA_EXPIRE_STORE_KEY, expireMap);
  }

  return { data, expireMap };
}

/**
 * 判断当前订单是否存在正式照片列表缓存。
 * @param {Object} query - 当前路由 query，用于生成订单维度缓存 key。
 * @returns {boolean} 当前订单缓存 key 存在时返回 true，空数组也视为存在。
 */
function hasPhotoListCache(query) {
  let now = +new Date();
  let r0 = getPhotoListDataWithTTL(now);
  let data = r0.data;
  let orderNo = getPhotoStoreKey(query);
  if (!orderNo) {
    Toast(`orderNo不存在`);
  }
  let storageKey = orderNo || 'default';
  return Object.prototype.hasOwnProperty.call(data, storageKey);
}

/**
 * 获取未保存照片列表 temp 缓存，并清理过期订单 key。
 * @param {number} now - 当前时间戳。
 * @returns {{data:Object,expireMap:Object}} temp 数据和过期时间映射。
 */
function getTempPhotoListDataWithTTL(now) {
  let data = Store.get(TEMP_PHOTO_LIST_DATA_STORE_KEY) || {};
  let expireMap = Store.get(TEMP_PHOTO_LIST_DATA_EXPIRE_STORE_KEY) || {};

  // temp 数据结构异常时重置为空对象，避免历史坏数据影响子页初始化。
  if (!data || typeof data !== 'object' || Array.isArray(data)) {
    data = {};
  }
  // temp 过期映射结构异常时重置为空对象，避免清理逻辑报错。
  if (!expireMap || typeof expireMap !== 'object' || Array.isArray(expireMap)) {
    expireMap = {};
  }

  let changedData = false;
  let changedExpire = false;
  for (let k in expireMap) {
    // 只处理当前对象自有 key，避免原型字段参与缓存清理。
    if (!Object.prototype.hasOwnProperty.call(expireMap, k)) {
      continue;
    }
    let expireAt = expireMap[k];
    // 过期时间异常时移除该订单 temp，避免长期叠加旧草稿。
    if (typeof expireAt !== 'number' || expireAt <= now) {
      delete expireMap[k];
      delete data[k];
      changedData = true;
      changedExpire = true;
      continue;
    }
    // data 中不存在的订单 key 不需要保留过期信息。
    if (!Object.prototype.hasOwnProperty.call(data, k)) {
      delete expireMap[k];
      changedExpire = true;
    }
  }
  for (let k in data) {
    // 只处理当前对象自有 key，避免原型字段参与缓存清理。
    if (!Object.prototype.hasOwnProperty.call(data, k)) {
      continue;
    }
    let expireAt = expireMap[k];
    // temp 缺少有效过期时间时直接清理，避免旧草稿被读取续期。
    if (typeof expireAt !== 'number' || expireAt <= now) {
      delete data[k];
      delete expireMap[k];
      changedData = true;
      changedExpire = true;
    }
  }

  // 清理到过期或异常 temp 数据时才回写数据缓存。
  if (changedData) {
    Store.set(TEMP_PHOTO_LIST_DATA_STORE_KEY, data);
  }
  // 过期映射发生变化时才回写过期时间缓存。
  if (changedExpire) {
    Store.set(TEMP_PHOTO_LIST_DATA_EXPIRE_STORE_KEY, expireMap);
  }
  return { data, expireMap };
}

/**
 * 清理指定订单 key 下的未保存照片 temp 缓存。
 * @param {string} storageKey - 订单维度缓存 key。
 * @returns {void}
 */
function clearTempPhotoListByStorageKey(storageKey) {
  let now = +new Date();
  let r0 = getTempPhotoListDataWithTTL(now);
  let data = r0.data;
  let expireMap = r0.expireMap;

  // 缺少订单 key 时无法定位 temp 缓存，直接结束清理。
  if (!storageKey) {
    return;
  }
  // 只有存在对应 temp 时才写 Store，减少无意义写入。
  if (Object.prototype.hasOwnProperty.call(data, storageKey)) {
    delete data[storageKey];
    delete expireMap[storageKey];
    Store.set(TEMP_PHOTO_LIST_DATA_STORE_KEY, data);
    Store.set(TEMP_PHOTO_LIST_DATA_EXPIRE_STORE_KEY, expireMap);
  }
}

/**
 * 按正式 photoListData 读取规则过滤照片列表。
 * @param {Array} list - 待过滤的照片列表。
 * @param {boolean} filter - 是否启用有效数据过滤。
 * @returns {Array} 过滤后的深拷贝列表。
 */
function filterPhotoList(list, filter) {
  let before = JSON.parse(JSON.stringify(list || []));
  let r = before.filter((v) => {
    let condition = true;
    // layerData 或 imageInfo 存在时，保存态必须带有效预览图。
    if (filter) {
      // 空项不参与保存态过滤，避免稀疏数组或坏数据触发读取异常。
      if (!v) {
        return false;
      }
      // 图层类照片优先从 layerData 中读取预览图。
      if (v.layerData) {
        condition = !!v.layerData.previewUrl || v.previewUrl;
      } else {
        // 非图层的图片信息存在时，使用顶层预览图判断。
        if (v.imageInfo) {
          condition = v.previewUrl;
        }
      }
      // 仅保留状态有效且满足预览图条件的照片。
      if (
        (!v.status || ['resolve', 'resolve_upload'].indexOf(v.status) > -1) &&
        condition
      ) {
        return true;
      }
      return false;
    }
    return true;
  });
  // 仅在过滤结果数量变化时记录调试日志。
  if (before.length != r.length) {
    console.log(
      `getPhotoList过滤, 过来前后数量 ${before.length} , ${r.length}`
    );
  }
  return r;
}

function getPhotoList(query, filter = false) {
  let now = +new Date();
  let r0 = getPhotoListDataWithTTL(now);
  let data = r0.data;
  let expireMap = r0.expireMap;
  let orderNo = getPhotoStoreKey(query);
  if (!orderNo) {
    Toast(`orderNo不存在`);
    //
    // throw new Error('orderNo不存在');
  }
  let storageKey = orderNo || 'default';
  let list = data[storageKey] || [];

  // 读取时顺延 24 小时（只对真实存在的 key 刷新）
  if (Object.prototype.hasOwnProperty.call(data, storageKey)) {
    expireMap[storageKey] = now + PHOTO_LIST_DATA_TTL_MS;
    Store.set(PHOTO_LIST_DATA_EXPIRE_STORE_KEY, expireMap);
  }

  return filterPhotoList(list, filter);
}

/**
 * 写入 edit 页面未保存的单张照片 temp 快照。
 * @param {Object} options - 写入参数。
 * @param {Object} options.query - 当前路由 query，用于生成订单维度缓存 key。
 * @param {number} options.index - 当前照片在 uploadPhotoList 中的索引。
 * @param {Object} options.item - 当前照片 item 快照。
 * @returns {void}
 */
function setTempPhotoList({ query, index, item }) {
  let now = +new Date();
  let orderNo = getPhotoStoreKey(query);
  // 缺少订单号时使用默认缓存 key，保持与正式照片列表一致。
  if (!orderNo) {
    Toast(`orderNo不存在`);
  }
  let storageKey = orderNo || 'default';
  let r0 = getTempPhotoListDataWithTTL(now);
  let data = r0.data;
  let expireMap = r0.expireMap;
  let numericIndex = Number(index);

  // index 无效或 item 为空时不写 temp，避免子页读取到不可定位的补丁。
  if (!Number.isInteger(numericIndex) || numericIndex < 0 || !item) {
    return;
  }
  // 当前订单 temp 结构缺失或异常时初始化为索引补丁容器。
  if (!data[storageKey] || typeof data[storageKey] !== 'object') {
    data[storageKey] = { items: {} };
  }
  // 当前订单的 items 结构缺失或异常时初始化为空对象。
  if (!data[storageKey].items || typeof data[storageKey].items !== 'object') {
    data[storageKey].items = {};
  }
  data[storageKey].items[String(numericIndex)] = item;
  expireMap[storageKey] = now + PHOTO_LIST_DATA_TTL_MS;

  Store.set(TEMP_PHOTO_LIST_DATA_STORE_KEY, data);
  Store.set(TEMP_PHOTO_LIST_DATA_EXPIRE_STORE_KEY, expireMap);
}

/**
 * 读取正式照片列表并叠加 edit 页面未保存的 temp 单张补丁。
 * @param {Object} query - 当前路由 query，用于生成订单维度缓存 key。
 * @param {boolean} [filter=false] - 是否按正式 photoListData 规则过滤有效数据。
 * @returns {Array} 合并 temp 后的照片列表。
 */
function getTempPhotoList(query, filter = false) {
  let now = +new Date();
  let orderNo = getPhotoStoreKey(query);
  // 缺少订单号时使用默认缓存 key，保持与正式照片列表一致。
  if (!orderNo) {
    Toast(`orderNo不存在`);
  }
  let storageKey = orderNo || 'default';
  let baseList = getPhotoList(query, false) || [];
  let mergedList = JSON.parse(JSON.stringify(baseList));
  let r0 = getTempPhotoListDataWithTTL(now);
  let data = r0.data;
  let expireMap = r0.expireMap;
  let tempItemMap =
    data[storageKey] && data[storageKey].items ? data[storageKey].items : {};

  // 读取到当前订单 temp 时顺延有效期，保持一次编辑会话内子页可连续读取。
  if (Object.prototype.hasOwnProperty.call(data, storageKey)) {
    expireMap[storageKey] = now + PHOTO_LIST_DATA_TTL_MS;
    Store.set(TEMP_PHOTO_LIST_DATA_EXPIRE_STORE_KEY, expireMap);
  }
  for (let index in tempItemMap) {
    // 只合并 temp 自有 index，避免原型字段污染数组。
    if (!Object.prototype.hasOwnProperty.call(tempItemMap, index)) {
      continue;
    }
    let numericIndex = Number(index);
    // temp index 无效时跳过该补丁，避免数组出现异常属性。
    if (!Number.isInteger(numericIndex) || numericIndex < 0) {
      continue;
    }
    mergedList[numericIndex] = tempItemMap[index];
  }
  return filterPhotoList(mergedList, filter);
}

function setPhotoList({ query, list }) {
  let now = +new Date();
  let orderNo = getPhotoStoreKey(query);
  if (!orderNo) {
    //
    Toast(`orderNo不存在`);
    // throw new Error('orderNo不存在');
  }

  let storageKey = orderNo || 'default';
  let r0 = getPhotoListDataWithTTL(now);
  let data = r0.data;
  let expireMap = r0.expireMap;

  data[storageKey] = list;
  expireMap[storageKey] = now + PHOTO_LIST_DATA_TTL_MS;

  Store.set(PHOTO_LIST_DATA_STORE_KEY, data, () => {
    let r = {};
    r[storageKey] = list;
    Store.set(PHOTO_LIST_DATA_STORE_KEY, r);

    // photoListData 写入失败时，expireMap 同步降级为仅当前 key
    let expireR = {};
    expireR[storageKey] = now + PHOTO_LIST_DATA_TTL_MS;
    Store.set(PHOTO_LIST_DATA_EXPIRE_STORE_KEY, expireR);
    clearTempPhotoListByStorageKey(storageKey);
  });
  Store.set(PHOTO_LIST_DATA_EXPIRE_STORE_KEY, expireMap);
  clearTempPhotoListByStorageKey(storageKey);
}

let timer;
// focusUpload 时的最小间隔时间（3秒）
let FOCUS_UPLOAD_INTERVAL = 3 * 1000;
// 非 focusUpload 时的最小间隔时间（30秒）
let NORMAL_UPLOAD_INTERVAL = 30 * 1000;

function uploadLogFile(focusUpload = false) {
  let lastUploadLogTime = Store.getSession('lastUploadLogTime');
  let now = +new Date();
  let timeSinceLastUpload = lastUploadLogTime
    ? now - lastUploadLogTime
    : Infinity;

  if (focusUpload) {
    // focusUpload 时，如果间隔小于3秒则不触发
    if (timeSinceLastUpload < FOCUS_UPLOAD_INTERVAL) {
      return;
    }
    Store.setSession('lastUploadLogTime', now);
    return _uploadLogFile();
  }

  // 非 focusUpload 时，保持原有逻辑（30秒间隔）
  if (!timer) {
    if (!lastUploadLogTime || timeSinceLastUpload > NORMAL_UPLOAD_INTERVAL) {
      Store.setSession('lastUploadLogTime', now);
      return _uploadLogFile();
    }
  }
  timer = setTimeout(() => {
    timer = null;
  }, NORMAL_UPLOAD_INTERVAL);
}

//
let autoUploadTimer = setInterval(() => {
  log.info('定时上传文件');
  uploadLogFile(true);
  clearInterval(autoUploadTimer);
  autoUploadTimer = null;
}, 7 * 60 * 1000);

async function _uploadLogFile(notClear = false, warning = 0) {
  log.info('lastUpdateTime:' + lastUpdateDateTime);
  let file = await createLogFile();
  if (file.size == 0) {
    return;
  }
  let res = await api.checkImage(file, {
    mediaType: 'log',
    poi: 0,
    temporary: 0,
    riskyCheck: 0,
    permanent: 1
  });
  res.warning = warning;
  if (!res.mediaId) {
    return;
  }
  let soId = Store.getSession('soId') || '';
  res.logCategory = soId;
  await api.wechatLog(res);
  // if (!notClear) {
  //   clearLogFile();
  // }
}

// 超过5mb自动上传
// if (getLogSize > 5 * 1024 * 1024) {
// uploadLogFile();
// }

const TextBottom = 0;
const TextLeft = 1;

function isSVGSupported() {
  return (
    !!document.createElementNS &&
    !!document.createElementNS('http://www.w3.org/2000/svg', 'svg')
      .createSVGRect
  );
}

const EXIF = require('exif-js');
function processExifData(imgSrc) {
  return new Promise((resolve, reject) => {
    let startTime = new Date().getTime();
    const image = new Image();
    image.src = imgSrc;
    image.onload = function () {
      // 检查图片是否有效
      if (!image.complete || image.naturalWidth === 0) {
        slog.error('Image not properly loaded');
        resolve({ rotated: false, message: '图片加载不完整，使用默认方向' });
        return;
      }
      setTimeout(() => {
        resolve({ rotated: false });
      }, 1500);
      // 使用setTimeout包装EXIF.getData调用，避免同步错误
      setTimeout(() => {
        try {
          EXIF.getData(image, function () {
            try {
              var orientation = EXIF.getTag(this, 'Orientation');
              var rotationInfo = checkIfRotated(orientation);
              report('util_parseExif', {
                time: formatLogTime(new Date() - startTime)
              });
              // console.log('exif parse', new Date() - startTime);
              resolve(rotationInfo); // Resolve with the rotation information
            } catch (error) {
              // 如果获取EXIF数据失败，返回默认的未旋转状态
              slog.error('EXIF.getTag failed:', error);
              resolve({
                rotated: false,
                message: 'EXIF数据解析失败，使用默认方向'
              });
            }
          });
        } catch (error) {
          // 如果EXIF.getData失败，返回默认的未旋转状态
          slog.error('EXIF.getData failed:', error);
          resolve({
            rotated: false,
            message: 'EXIF数据读取失败，使用默认方向'
          });
        }
      }, 0);
      image.onerror = reject;
    };
  });
}

function checkIfRotated(orientation) {
  if (!orientation || orientation === 1) {
    return { rotated: false, message: 'The image is not rotated.' };
  } else {
    let rotationMessage;
    switch (orientation) {
      case 3:
        rotationMessage = 'Rotate 180 degrees';
        break;
      case 6:
        rotationMessage = 'Rotate 90 degrees CW';
        break;
      case 8:
        rotationMessage = 'Rotate 90 degrees CCW';
        break;
      default:
        rotationMessage = 'Other rotation values may need special handling';
    }
    return {
      rotated: true,
      message: rotationMessage,
      orientation: orientation
    };
  }
}

import * as piexif from 'piexifjs';

// 定义一个函数，用于使用piexifjs库移除图片的EXIF数据
/**
 * 使用Piexif.js移除JPEG图片的EXIF数据
 * @param {File} file - 需要移除EXIF数据的JPEG图片文件
 * @returns {Promise<string>} - 返回一个Promise对象，成功时解析为移除EXIF数据后的图片数据（Base64格式）
 */
function removeFileExif(file) {
  let startTime = new Date();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (e) {
      try {
        // 1. 读取图片数据（需为JPEG格式）
        const jpegData = e.target.result;
        // 2. 移除EXIF数据
        console.log(222222);

        const cleanData = piexif.remove(jpegData);
        resolve(cleanData);
        report('util_removeExif', {
          time: formatLogTime(new Date() - startTime)
        });
      } catch (error) {
        report('util_removeExifFail', {
          time: formatLogTime(new Date() - startTime),
          reason: error && error.message
        });
        reject(new Error('EXIF移除失败: ' + error.message));
      }
    };
    reader.onerror = () => reject(new Error('文件读取失败'));
    reader.readAsDataURL(file); // 以二进制格式读取文件
  });
}

/**
 * 异步移除文件的EXIF信息
 * @param {File|Blob} file - 需要移除EXIF信息的文件对象
 * @returns {Promise<string>} - 返回移除EXIF信息后的文件内容（blobUrl格式）
 * @throws {Error} - 如果文件大小为0或文件类型不是File或Blob，则抛出错误
 */
async function removeRotatedImageExif(file) {
  // 获取当前时间
  let startTime = new Date();
  let result;
  // 判断文件大小是否为0
  if (file.size == 0) {
    // 如果文件大小为0，抛出错误
    throw new Error('file size is 0');
  } else {
    // 判断文件是否为File或Blob类型
    if (file instanceof File || file instanceof Blob) {
      // 将文件转换为base64格式
      let imageSrc = await fileToBase64(file);
      let time2 = new Date();
      logTime('fileToBase64耗时:' + (new Date() - time2));
      // 处理EXIF数据
      let time3 = new Date();
      let exifInfo = await processExifData(imageSrc);
      logTime('processExifData耗时:' + (new Date() - time3));
      // 判断是否需要旋转
      if (exifInfo.rotated) {
        try {
          // 使用piexifjs移除EXIF信息
          result = await removeFileExif(file);
        } catch (error) {
          log.error(error);
          throw error;
          // 处理错误
        }
      } else {
        result = imageSrc;
      }
      logTime(
        `removeExif耗时:${new Date() - startTime},rotated=${exifInfo.rotated}`
      );
      report('util_removeRotatedImageExif', {
        time: formatLogTime(new Date() - startTime)
      });
      let blobUrl = base64ToBlobUrl(result);
      return blobUrl;
    } else {
      throw new Error('file is not a file or blob');
    }
  }
}

function copyUrlParams(str = window.location.href, mergeObj = {}) {
  let queryParams = {};
  const queryString = str.split('?')[1];
  if (!queryString) return '';

  const pairs = queryString.split('&');
  for (const pair of pairs) {
    const [key, value] = pair.split('=');
    queryParams[key] = value || '';
  }
  let result = '';
  queryParams.t = +new Date();
  queryParams = { ...queryParams, ...mergeObj };
  Object.keys(queryParams).forEach((key) => {
    result += `${key}=${queryParams[key]}&`;
  });
  result = result.replace(/\&$/, '');
  return result;
}

function deepCopy(data) {
  return JSON.parse(JSON.stringify(data));
}

function toFixed(number, precision) {
  return parseFloat(number.toFixed(precision));
}

function getStore({ namespace, key }) {
  let info = Store.get(namespace) || {};
  return info[key];
}

function setStore({ namespace, key, val }) {
  let info = Store.get(namespace) || {};
  info[key] = val;
  return Store.set(namespace, info);
}

/**
 * 从当前网页链接中读取指定参数值，兼容 hash 路由上的查询参数。
 * @param {string} paramName 参数名称
 * @returns {string} 当前链接里的参数值
 */
function getLocationParam(paramName) {
  let href = (window.location && window.location.href) || '';
  let queryList = [];

  // 常规 search 参数和 hash 路由参数都需要识别，避免依赖 UI 路由对象取值。
  if (href.indexOf('?') > -1) {
    queryList = href
      .split('?')
      .slice(1)
      .map((query) => query.split('#')[0]);
  }

  for (let i = 0; i < queryList.length; i++) {
    let params = new URLSearchParams(queryList[i]);
    let value = params.get(paramName);

    // URL 中匹配到参数后，直接返回当前网页链接里的值。
    if (value !== null) {
      return value;
    }
  }

  return '';
}

/**
 * 按当前链接中的 outerOiId 存储物理蒙版 URL。
 * @param {string} physicalMaskUrl 物理蒙版 URL
 * @returns {void}
 */
function setCurrentOuterOiIdPhysicalMaskUrl(physicalMaskUrl) {
  let outerOiId = getLocationParam('outerOiId');

  // 当前链接没有 outerOiId 时不写入，避免无业务维度的全局串值。
  if (!outerOiId) {
    return;
  }

  let physicalMaskUrlMap = Store.get('physicalMaskUrl') || {};

  // 旧版本可能已存成字符串，这里统一转成按 outerOiId 存储的对象。
  if (typeof physicalMaskUrlMap !== 'object') {
    physicalMaskUrlMap = {};
  }

  physicalMaskUrlMap[outerOiId] = physicalMaskUrl;
  Store.set('physicalMaskUrl', physicalMaskUrlMap);
}

/**
 * 按当前链接中的 outerOiId 读取已存储的物理蒙版 URL。
 * @returns {string} 当前 outerOiId 命中的物理蒙版 URL，未命中时返回空字符串
 */
function getCurrentOuterOiIdPhysicalMaskUrl() {
  let outerOiId = getLocationParam('outerOiId');

  // 当前链接没有 outerOiId 时不读取，避免取到其他子订单的数据。
  if (!outerOiId) {
    return '';
  }

  let physicalMaskUrlMap = Store.get('physicalMaskUrl') || {};

  // 旧版本可能已存成字符串，非映射结构不参与当前 outerOiId 匹配。
  if (typeof physicalMaskUrlMap !== 'object') {
    return '';
  }

  return physicalMaskUrlMap[outerOiId] || '';
}

!(function (n, e) {
  function setViewHeight() {
    var windowVH = e.innerHeight / 100;
    n.documentElement.style.setProperty('--vh', windowVH + 'px');
  }
  var i = 'orientationchange' in window ? 'orientationchange' : 'resize';
  n.addEventListener('DOMContentLoaded', setViewHeight);
  e.addEventListener(i, setViewHeight);
})(document, window);

function selectFile({ accept, multiple }) {
  return new Promise((resolve, reject) => {
    const input = document.createElement('input');
    input.type = 'file';
    if (accept) {
      input.accept = accept; // 设置文件类型
    }
    if (multiple) {
      input.multiple = multiple; // 设置文件类型
    }
    input.style.display = 'none';

    input.addEventListener('change', (event) => {
      if (event.target.files.length > 0) {
        resolve(event); // 返回事件对象
        document.body.removeChild(input);
      } else {
        reject(new Error('未选择文件'));
      }
    });

    document.body.appendChild(input);
    input.click();
  });
}

function rafThrottle(fn, options = { immediate: true }) {
  const raf =
    window.requestAnimationFrame || ((callback) => setTimeout(callback, 16));
  let isPending = false;
  let lastArgs = null;
  let context = null;

  const throttled = function (...args) {
    lastArgs = args;
    context = this;

    if (!isPending) {
      if (options.immediate) {
        fn.apply(context, lastArgs); // 首次立即执行
      }
      isPending = true;
      raf(() => {
        isPending = false;
        fn.apply(context, lastArgs); // 下一帧执行最后一次调用
      });
    }
  };

  return throttled;
}

function getImageDimensions(file) {
  return new Promise((resolve, reject) => {
    if (!file || !file.type.startsWith('image/')) {
      reject(new Error('File is not an image.'));
      return;
    }

    const img = new Image();
    const reader = new FileReader();

    reader.onload = function (e) {
      img.src = e.target.result;
    };

    reader.onerror = function (e) {
      reject(new Error('Failed to read the file.'));
    };

    img.onload = function () {
      resolve({ width: img.width, height: img.height });
    };

    img.onerror = function (e) {
      reject(new Error('Failed to load the image.'));
    };

    reader.readAsDataURL(file);
  });
}

function parseParams() {
  const paramsString = window.location.href.replace(/[^?]+\?/, '');
  const params = {};
  paramsString.split('&').forEach((param) => {
    const [key, value] = param.split('=');
    params[key] = decodeURIComponent(value);
  });
  return params;
}

function retryWithCheck(fn, checkFn, repeatTimes) {
  let attempts = 0;

  function execute() {
    return Promise.resolve()
      .then(() => fn())
      .then((result) => {
        const isValid = checkFn(result);
        if (!isValid && attempts < repeatTimes) {
          attempts++;
          return execute(); // 递归调用进行重试
        }
        return isValid
          ? result
          : Promise.reject(new Error(`Max retries (${repeatTimes}) exceeded`));
      });
  }

  return execute();
}

window.addEventListener('orientationchange', () => {
  log.info('触发orientationchange' + window.orientation);
});

window.addEventListener('resize', () => {
  log.info('触发resize');
});

window.addEventListener('unhandledrejection', (event) => {
  event.preventDefault(); // 禁止！！！
});

var PNG_SIGNATURE = [0x89, 0x50, 0x4e, 0x47, 0x0d, 0x0a, 0x1a, 0x0a];

/**
 * 判断入参形态
 * @param {File|Blob|string} input
 * @returns {'file'|'blob'|'blobUrl'|'base64'|''}
 */
function getImageInputKind(input) {
  if (!input) {
    return '';
  }
  if (input instanceof File) {
    return 'file';
  }
  if (typeof Blob !== 'undefined' && input instanceof Blob) {
    return 'blob';
  }
  if (typeof input === 'string') {
    if (input.indexOf('blob:') === 0) {
      return 'blobUrl';
    }
    if (/^data:image\/\w+;base64,/.test(input)) {
      return 'base64';
    }
  }
  return '';
}

/**
 * 读取 PNG 块类型名（4 字节 ASCII）
 * @param {Uint8Array} bytes
 * @param {number} offset
 * @returns {string}
 */
function getPngChunkType(bytes, offset) {
  return String.fromCharCode(
    bytes[offset],
    bytes[offset + 1],
    bytes[offset + 2],
    bytes[offset + 3]
  );
}

/**
 * 读取大端 uint32
 * @param {Uint8Array} bytes
 * @param {number} offset
 * @returns {number}
 */
function readUint32BE(bytes, offset) {
  return (
    ((bytes[offset] << 24) |
      (bytes[offset + 1] << 16) |
      (bytes[offset + 2] << 8) |
      bytes[offset + 3]) >>>
    0
  );
}

/**
 * Blob 转 Uint8Array
 * @param {Blob} blob
 * @returns {Promise<Uint8Array>}
 */
function blobToUint8Array(blob) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function (e) {
      resolve(new Uint8Array(e.target.result));
    };
    reader.onerror = function (err) {
      reject(err);
    };
    reader.readAsArrayBuffer(blob);
  });
}

/**
 * base64 data URL 转 Blob
 * @param {string} dataUrl
 * @returns {{ blob: Blob, mimeType: string }}
 */
function dataUrlToBlob(dataUrl) {
  var parts = dataUrl.split(';base64,');
  var mimeType = 'image/png';
  if (parts[0].indexOf('data:') === 0) {
    mimeType = parts[0].slice(5) || mimeType;
  }
  var raw = window.atob(parts[1]);
  var byteArray = new Uint8Array(raw.length);
  var i;
  for (i = 0; i < raw.length; i++) {
    byteArray[i] = raw.charCodeAt(i);
  }
  return {
    blob: new Blob([byteArray], { type: mimeType }),
    mimeType: mimeType
  };
}

/**
 * 是否 PNG（MIME 或文件头）
 * @param {string} mimeType
 * @param {Uint8Array} bytes
 * @returns {boolean}
 */
function isPngImage(mimeType, bytes) {
  if (mimeType && mimeType.indexOf('png') > -1) {
    return true;
  }
  if (!bytes || bytes.length < 8) {
    return false;
  }
  var i;
  for (i = 0; i < PNG_SIGNATURE.length; i++) {
    if (bytes[i] !== PNG_SIGNATURE[i]) {
      return false;
    }
  }
  return true;
}

/**
 * 将 File / Blob / blobUrl / base64 归一化为 Blob 与字节
 * @param {File|Blob|string} input
 * @param {Object} [opt]
 * @param {string} [opt.mimeType] - 强制 MIME
 * @returns {Promise<{ blob: Blob, bytes: Uint8Array, mimeType: string, inputKind: string, originalInput: *, fileName: string }>}
 */
function resolveImageInputToBlob(input, opt) {
  opt = opt || {};
  var inputKind = getImageInputKind(input);
  if (!inputKind) {
    return Promise.reject(new Error('不支持的图片入参类型'));
  }

  function finish(blob, originalInput, fileName) {
    var mimeType = opt.mimeType || blob.type || 'image/png';
    return blobToUint8Array(blob).then(function (bytes) {
      return {
        blob: blob,
        bytes: bytes,
        mimeType: mimeType,
        inputKind: inputKind,
        originalInput: originalInput,
        fileName: fileName || 'image.png'
      };
    });
  }

  if (inputKind === 'file') {
    return finish(input, input, input.name || 'image.png');
  }
  if (inputKind === 'blob') {
    return finish(input, input, 'image.png');
  }
  if (inputKind === 'blobUrl') {
    var mappedFile = getFileFromBlobUrl(input);
    if (mappedFile && mappedFile.size) {
      return finish(mappedFile, input, mappedFile.name || 'image.png');
    }
    return fetchBlob(input).then(function (blob) {
      return finish(blob, input, 'image.png');
    });
  }
  var parsed = dataUrlToBlob(input);
  return finish(parsed.blob, input, 'image.png');
}

/**
 * 严格校验 PNG 二进制（签名、chunk CRC、IHDR、IDAT、IEND）
 * @param {Uint8Array} bytes
 * @returns {{ valid: boolean, reason: string }}
 */
function validatePngBytes(bytes) {
  var i;
  var offset;
  var length;
  var chunkType;
  var crcPos;
  var expectedCrc;
  var computedCrc;
  var crcBuf;
  var hasIdat;

  if (!bytes || bytes.length < 33) {
    return { valid: false, reason: 'PNG 数据过短' };
  }
  for (i = 0; i < PNG_SIGNATURE.length; i++) {
    if (bytes[i] !== PNG_SIGNATURE[i]) {
      return { valid: false, reason: 'PNG 文件签名无效' };
    }
  }

  offset = 8;
  hasIdat = false;

  while (offset + 12 <= bytes.length) {
    length = readUint32BE(bytes, offset);
    chunkType = getPngChunkType(bytes, offset + 4);

    if (length < 0 || offset + 12 + length > bytes.length) {
      return { valid: false, reason: 'PNG chunk 长度非法: ' + chunkType };
    }

    if (offset === 8) {
      if (chunkType !== 'IHDR' || length !== 13) {
        return { valid: false, reason: 'PNG 缺少合法 IHDR' };
      }
    }

    if (chunkType === 'IDAT') {
      hasIdat = true;
    }

    crcBuf = bytes.subarray(offset + 4, offset + 8 + length);
    crcPos = offset + 8 + length;
    expectedCrc = readUint32BE(bytes, crcPos);
    computedCrc = calcCrc(crcBuf) >>> 0;

    if (expectedCrc !== computedCrc) {
      return {
        valid: false,
        reason: 'PNG chunk CRC 校验失败: ' + chunkType
      };
    }

    if (chunkType === 'IEND') {
      if (offset + 12 + length !== bytes.length) {
        return { valid: false, reason: 'PNG IEND 后存在多余数据' };
      }
      if (!hasIdat) {
        return { valid: false, reason: 'PNG 缺少 IDAT' };
      }
      return { valid: true, reason: '' };
    }

    offset += 12 + length;
  }

  return { valid: false, reason: 'PNG 未找到 IEND' };
}

/**
 * Canvas 导出 PNG Blob
 * @param {HTMLCanvasElement} canvas
 * @returns {Promise<Blob>}
 */
function exportCanvasToPngBlob(canvas) {
  return new Promise(function (resolve, reject) {
    if (typeof canvas.toBlob === 'function') {
      canvas.toBlob(
        function (blob) {
          if (blob) {
            resolve(blob);
          } else {
            reject(new Error('canvas.toBlob 失败'));
          }
        },
        'image/png',
        1
      );
    } else {
      try {
        var parsed = dataUrlToBlob(canvas.toDataURL('image/png'));
        resolve(parsed.blob);
      } catch (err) {
        reject(err);
      }
    }
  });
}

/**
 * Blob 转 base64 data URL
 * @param {Blob} blob
 * @returns {Promise<string>}
 */
function blobToDataUrl(blob) {
  return new Promise(function (resolve, reject) {
    var reader = new FileReader();
    reader.onload = function (e) {
      resolve(e.target.result);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

/**
 * 按入参形态输出修复结果
 * @param {Blob} blob
 * @param {string} inputKind
 * @param {*} originalInput
 * @param {string} fileName
 * @returns {Promise<File|Blob|string>}
 */
function formatImageOutputByInputKind(
  blob,
  inputKind,
  originalInput,
  fileName
) {
  if (inputKind === 'file') {
    return Promise.resolve(
      new File([blob], fileName, {
        type: blob.type || 'image/png',
        lastModified: Date.now()
      })
    );
  }
  if (inputKind === 'blob') {
    return Promise.resolve(blob);
  }
  if (inputKind === 'blobUrl') {
    return Promise.resolve(URL.createObjectURL(blob));
  }
  return blobToDataUrl(blob);
}

/**
 * 检测图片完整性（仅 PNG 做严格二进制校验，其它格式视为完整）
 * @param {File|Blob|string} input - File/Blob、blob: URL、data:image/...;base64,...
 * @param {Object} [opt]
 * @param {string} [opt.mimeType] - 强制按某 MIME 判断是否为 PNG
 * @returns {Promise<{ valid: boolean, isPng: boolean, reason: string }>}
 *   valid: 是否通过检测（非 PNG 恒为 true）
 *   isPng: 是否按 PNG 规则检测
 *   reason: 未通过时的原因，通过时为空字符串
 */
function detectImageIntegrity(input, opt) {
  return resolveImageInputToBlob(input, opt).then(function (resolved) {
    var isPng = isPngImage(resolved.mimeType, resolved.bytes);
    if (!isPng) {
      return { valid: true, isPng: false, reason: '' };
    }
    var check = validatePngBytes(resolved.bytes);
    return {
      valid: check.valid,
      isPng: true,
      reason: check.reason || ''
    };
  });
}

/**
 * 修复 PNG 图片（Canvas 重编码；非 PNG 或已完好的 PNG 原样返回）
 * @param {File|Blob|string} input - 与 detectImageIntegrity 相同
 * @param {Object} [opt]
 * @param {string} [opt.mimeType] - 强制 MIME
 * @returns {Promise<{ data: File|Blob|string, repaired: boolean }>}
 *   data: 与入参同类型的最终数据
 *   repaired: 是否经过 Canvas 重编码
 */
function repairImageIntegrity(input, opt) {
  var tempUrl = '';
  return resolveImageInputToBlob(input, opt)
    .then(function (resolved) {
      var isPng = isPngImage(resolved.mimeType, resolved.bytes);
      if (!isPng) {
        return {
          data: resolved.originalInput,
          repaired: false
        };
      }
      var check = validatePngBytes(resolved.bytes);
      if (check.valid) {
        return {
          data: resolved.originalInput,
          repaired: false
        };
      }
      tempUrl = URL.createObjectURL(resolved.blob);
      return loadImage(tempUrl).then(function (img) {
        var canvas = document.createElement('canvas');
        var ctx = canvas.getContext('2d');
        var w = img.naturalWidth || img.width;
        var h = img.naturalHeight || img.height;
        if (!w || !h) {
          throw new Error('图片尺寸无效，无法修复');
        }
        canvas.width = w;
        canvas.height = h;
        ctx.drawImage(img, 0, 0, w, h);
        return exportCanvasToPngBlob(canvas).then(function (repairedBlob) {
          return blobToUint8Array(repairedBlob).then(function (bytes) {
            var reCheck = validatePngBytes(bytes);
            if (!reCheck.valid) {
              throw new Error(
                'PNG 重编码后仍无法通过校验: ' + (reCheck.reason || '')
              );
            }
            return formatImageOutputByInputKind(
              repairedBlob,
              resolved.inputKind,
              resolved.originalInput,
              resolved.fileName
            ).then(function (data) {
              return { data: data, repaired: true };
            });
          });
        });
      });
    })
    .finally(function () {
      if (tempUrl) {
        URL.revokeObjectURL(tempUrl);
      }
    });
}

/**
 * 获取图片格式（支持Blob URL和Base64）
 * @param {string} input - Blob URL或Base64字符串
 * @returns {Promise<string>} 图片格式（如'png'、'jpg'）
 */
async function getImageType(input) {
  try {
    // 判断输入类型
    if (input.indexOf('blob:') > -1) {
      // Blob URL处理逻辑
      const blob = await fetchBlob(input);
      return extractFormatFromMime(blob.type);
    } else if (/^data:image\/(\w+);base64,/.test(input)) {
      // Base64处理逻辑
      return input.match(/^data:image\/(\w+);base64,/)[1];
    } else {
      throw new Error('不支持的输入格式');
    }
  } catch (error) {
    console.error('获取图片格式失败:', error);
    return '';
  }
}

// 辅助函数：通过Blob URL获取Blob对象
function fetchBlob(blobUrl) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open('GET', blobUrl);
    xhr.responseType = 'blob';
    xhr.onload = () =>
      xhr.status === 200
        ? resolve(xhr.response)
        : reject(new Error(`请求失败: ${xhr.status}`));
    xhr.onerror = () => reject(new Error('网络错误'));
    xhr.send();
  });
}

// 辅助函数：从MIME类型提取格式
function extractFormatFromMime(mimeType) {
  return mimeType.split('/')[1];
}

function getDouyinData() {
  let localDyData = null;
  try {
    localDyData = Store.getSession('dyData');
  } catch (error) {}
  return window._dyData || localDyData;
}

function setDouyinData(data) {
  let copyData = JSON.parse(JSON.stringify(data));
  Store.setSession('dyData', copyData);
  window._dyData = copyData;
}

export function getWxData() {
  let localWxData = null;
  try {
    localWxData = Store.getSession('wxData');
  } catch (error) {}
  return window._wxData || localWxData;
}

export function setWxData(data) {
  let copyData = JSON.parse(JSON.stringify(data));
  Store.setSession('wxData', copyData);
  window._wxData = copyData;
}

import asyncLoadJs from '@/utils/asyncLoadJs';
let loadPromise = null; // 用于保存加载Promise

function loadJsSdk(appType) {
  const jsMap = {
    wx: '//res.wx.qq.com/open/js/jweixin-1.6.0.js', // 微信
    tt: '//lf1-cdn-tos.bytegoofy.com/goofy/developer/jssdk/jssdk-1.1.0.js' // 抖音
  };

  if (!jsMap[appType]) {
    return Promise.reject(new Error('不支持的appType'));
  }

  // 如果已经有加载中的Promise，直接返回它
  if (loadPromise) {
    return loadPromise;
  }

  // 创建新的加载Promise
  loadPromise = asyncLoadJs(jsMap[appType])
    .then((result) => {
      return result;
    })
    .catch((error) => {
      // 加载失败后重置loadPromise，允许后续重新加载
      loadPromise = null;
      throw error;
    });

  return loadPromise;
}

setTimeout(() => {
  let dyData = getDouyinData();
  if (dyData) {
    // 与家长抖音sdk
    loadJsSdk('tt');
  }
}, 1000);

function setOrderFinishList(orderNo) {
  let data = [];
  try {
    data = Store.get('orderFinishList');
    if (!data) {
      data = [];
    }
  } catch (error) {}
  if (!Array.isArray(data)) {
    data = [];
  }
  if (!data.indexOf(orderNo) > -1) {
    data.unshift(orderNo);
    data = data.slice(0, 10);
  }
  Store.set('orderFinishList', data);
}

function getOrderFinishList(orderNo) {
  let data = [];
  try {
    data = Store.get('orderFinishList');
    if (!data) {
      data = [];
    }
  } catch (error) {}
  if (!Array.isArray(data)) {
    data = [];
  }
  return data.indexOf(orderNo) > -1;
}

async function finishSubmit({ $router, goodsDetail, cb, waitPromise }) {
  let dyData = getDouyinData();
  let wxData = getWxData();
  let isDouyinApp = dyData && dyData.orderNo; // 是否在抖音小程序中
  // uploadLogFile(true);
  if (isDouyinApp) {
    let miniProgram = window.tt.miniProgram;
    let isFinish = getOrderFinishList(dyData.orderNo);
    if (isFinish) {
      // 抖音提交定制接口失败,进行重试
      await confirmModal({
        content: '页面返回后,请勿进行操作,等待数据提交完成',
        showCancel: false,
        confirmText: '确定'
      });
    }
    setOrderFinishList(dyData.orderNo);
    setDouyinData('');
    miniProgram.postMessage({
      data: {
        type: constant.miniAppWebBridgeMap.submitPrint
      }
    });
    report('finish_submit_douyin');
    cb && cb();
    miniProgram.navigateBack({ delta: 1 });
  } else if (wxData) {
    let miniProgram = window.wx.miniProgram;
    if (wxData.itemId) {
      // 小程序sku上传
      miniProgram.postMessage({
        data: {
          type:
            wxData.action == constant.miniAppWebBridgeMap.addMyWork
              ? constant.miniAppWebBridgeMap.addMyWork
              : constant.miniAppWebBridgeMap.submitPrint,
          goodsDetail
        }
      });
    } else {
      // 外部订单导入小程序
      miniProgram.postMessage({
        data: {
          type: constant.miniAppWebBridgeMap.importOrder
        }
      });
    }
    Toast('提交成功');
    if (waitPromise) {
      await waitPromise;
    }
    cb && cb();
    miniProgram.navigateBack({ delta: 1 });
    setWxData('');
  } else {
    cb && cb();
    $router.push(`/finish?t=${+new Date()}`);
  }
}

function isDouyinApp() {
  let dyData = getDouyinData();
  let isDouyinApp = dyData && dyData.orderNo; // 是否在抖音小程序中
  return isDouyinApp;
}

export function getElementPosition(element) {
  const rect = element.getBoundingClientRect();
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

  return {
    left: rect.left + scrollLeft,
    top: rect.top + scrollTop
  };
}

export function setToken(token) {
  window._token = token;
  Store.set('token', token);
  Store.setSession('token', token);
}

export function getToken() {
  return window._token || Store.get('token') || Store.getSession('token') || '';
}

export function getErrorMessage(error, defaultMsg = '处理失败') {
  let msg = error && error.message ? error.message : '';
  let filterList = ['undefined', 'null'];
  let isMatch = filterList.some(
    (v) => msg.indexOf(v) > -1 || v.indexOf(msg) > -1
  );
  if (isMatch) {
    return defaultMsg;
  } else {
    return msg || defaultMsg;
  }
}

export function keepZero(str) {
  if (
    str === 'undefined' ||
    str === 'null' ||
    str === undefined ||
    str === null
  ) {
    return '';
  }
  if (str === 0 || str === '0') {
    return 0;
  } else {
    return str || '';
  }
}

/**
 * 功能说明：根据路由 pageBack 参数获取返回层级。
 * @param {string|number} pageBack - 路由 query 中的 pageBack 参数
 * @param {number} defaultPageBack - pageBack 无效时使用的默认返回层级
 * @returns {number} 可传入 router.go 或 backStep 的返回层级
 */
export function getPageBack(pageBack, defaultPageBack = -1, moreBack = 0) {
  let backStep = defaultPageBack;
  // pageBack 有效时，优先使用路由指定的返回层级。
  if (
    pageBack !== undefined &&
    pageBack !== null &&
    pageBack !== '' &&
    !isNaN(Number(pageBack))
  ) {
    backStep = Number(pageBack - moreBack);
  }
  return backStep;
}

export function parseWxDataAndLoadJsSdk(wxData) {
  try {
    let miniAppData;
    try {
      miniAppData = typeof wxData === 'string' ? JSON.parse(wxData) : wxData;
    } catch (error) {}
    if (!miniAppData) {
      miniAppData = getWxData();
    }
    if (miniAppData && miniAppData.token) {
      // wxData数据有效
      setToken(miniAppData.token);
      Store.set('__uid', miniAppData.uid);
      if (miniAppData.action == constant.miniAppWebBridgeMap.importThirdOrder) {
        miniAppData.isGc = 0;
      }

      setWxData(miniAppData);
      loadJsSdk('wx'); // 加载微信sdk
      if (miniAppData.deviceId) {
        Store.set('deviceId', miniAppData.deviceId);
      }
    }
  } catch (error) {
    console.error(error);
    // 处理错误
  }
}
function clearAllCookies() {
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i];
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();

    // 设置过期时间为过去的时间，使 Cookie 失效
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`;
  }
}
export function clearCookieIfNeed() {
  if (document.cookie.length > 10 * 1000) {
    clearAllCookies();
    return true;
  }
}

const CACHE_PROMISE_DEFAULT_TYPE = '__default__';

function normalizeCachePromiseKey(cacheKey) {
  if (cacheKey === undefined || cacheKey === null || cacheKey === '') {
    throw new Error('cachePromise: cacheKey 不能为空');
  }
  if (typeof cacheKey == 'object') {
    return JSON.stringify(cacheKey);
  }
  return String(cacheKey);
}

function normalizeCachePromiseType(type) {
  if (type === undefined || type === null || type === '') {
    return CACHE_PROMISE_DEFAULT_TYPE;
  }
  return String(type);
}

function buildCachePromiseCompositeKey(normalizedType, normalizedKey) {
  return normalizedType + '\x00' + normalizedKey;
}

function registerCachePromiseIndex(
  normalizedType,
  normalizedKey,
  compositeKey
) {
  if (!cachePromiseTypeIndex[normalizedType]) {
    cachePromiseTypeIndex[normalizedType] = {};
  }
  cachePromiseTypeIndex[normalizedType][compositeKey] = normalizedKey;

  if (!cachePromiseCacheKeyIndex[normalizedKey]) {
    cachePromiseCacheKeyIndex[normalizedKey] = {};
  }
  cachePromiseCacheKeyIndex[normalizedKey][normalizedType] = compositeKey;
}

function removeCachePromiseIndexEntry(
  normalizedType,
  normalizedKey,
  compositeKey
) {
  if (cachePromiseTypeIndex[normalizedType]) {
    delete cachePromiseTypeIndex[normalizedType][compositeKey];
    if (Object.keys(cachePromiseTypeIndex[normalizedType]).length === 0) {
      delete cachePromiseTypeIndex[normalizedType];
    }
  }
  if (cachePromiseCacheKeyIndex[normalizedKey]) {
    delete cachePromiseCacheKeyIndex[normalizedKey][normalizedType];
    if (Object.keys(cachePromiseCacheKeyIndex[normalizedKey]).length === 0) {
      delete cachePromiseCacheKeyIndex[normalizedKey];
    }
  }
}

function deleteCachePromiseByCompositeKey(
  compositeKey,
  normalizedType,
  normalizedKey
) {
  cachePromiseCache.delete(compositeKey);
  delete cachePromisePendingMap[compositeKey];
  removeCachePromiseIndexEntry(normalizedType, normalizedKey, compositeKey);
}

/**
 * 删除指定 cacheKey（以及可选 type）的缓存
 * - 传 type：只删该 type 下这一条
 * - 不传 type：删除该 cacheKey 下所有 type 的版本
 */
export function deleteCachePromise(cacheKey, type) {
  const normalizedKey = normalizeCachePromiseKey(cacheKey);

  if (type !== undefined && type !== null && type !== '') {
    const normalizedType = normalizeCachePromiseType(type);
    const compositeKey = buildCachePromiseCompositeKey(
      normalizedType,
      normalizedKey
    );
    deleteCachePromiseByCompositeKey(
      compositeKey,
      normalizedType,
      normalizedKey
    );
    return;
  }

  // 不传 type：删除所有 type 下的该 cacheKey 版本
  const typeMap = cachePromiseCacheKeyIndex[normalizedKey];
  if (typeMap) {
    var typesToDelete = Object.keys(typeMap);
    for (var i = 0; i < typesToDelete.length; i++) {
      var t = typesToDelete[i];
      var ck = typeMap[t];
      cachePromiseCache.delete(ck);
      delete cachePromisePendingMap[ck];
      if (cachePromiseTypeIndex[t]) {
        delete cachePromiseTypeIndex[t][ck];
        if (Object.keys(cachePromiseTypeIndex[t]).length === 0) {
          delete cachePromiseTypeIndex[t];
        }
      }
    }
    delete cachePromiseCacheKeyIndex[normalizedKey];
  }
}

/**
 * 删除指定 type 下的所有缓存
 */
export function deleteCachePromiseByType(type) {
  const normalizedType = normalizeCachePromiseType(type);
  const compositeKeyMap = cachePromiseTypeIndex[normalizedType];
  if (!compositeKeyMap) {
    return;
  }
  var compositeKeys = Object.keys(compositeKeyMap);
  for (var i = 0; i < compositeKeys.length; i++) {
    var compositeKey = compositeKeys[i];
    var normalizedKey = compositeKeyMap[compositeKey];
    cachePromiseCache.delete(compositeKey);
    delete cachePromisePendingMap[compositeKey];
    if (cachePromiseCacheKeyIndex[normalizedKey]) {
      delete cachePromiseCacheKeyIndex[normalizedKey][normalizedType];
      if (Object.keys(cachePromiseCacheKeyIndex[normalizedKey]).length === 0) {
        delete cachePromiseCacheKeyIndex[normalizedKey];
      }
    }
  }
  delete cachePromiseTypeIndex[normalizedType];
}

export function clearCachePromise() {
  cachePromiseCache.clear();
  Object.keys(cachePromisePendingMap).forEach((key) => {
    delete cachePromisePendingMap[key];
  });
  Object.keys(cachePromiseTypeIndex).forEach((key) => {
    delete cachePromiseTypeIndex[key];
  });
  Object.keys(cachePromiseCacheKeyIndex).forEach((key) => {
    delete cachePromiseCacheKeyIndex[key];
  });
}

export function cachePromise({
  promiseCb,
  cacheKey,
  type,
  expirationTime,
  cacheCallback
}) {
  if (typeof promiseCb !== 'function') {
    return Promise.reject(new Error('cachePromise: promiseCb 必须是函数'));
  }

  const normalizedKey = normalizeCachePromiseKey(cacheKey);
  const normalizedType = normalizeCachePromiseType(type);
  const compositeKey = buildCachePromiseCompositeKey(
    normalizedType,
    normalizedKey
  );

  if (cachePromiseCache.has(compositeKey)) {
    if (typeof cacheCallback === 'function') {
      cacheCallback();
    }
    return Promise.resolve(cachePromiseCache.get(compositeKey));
  }

  if (cachePromisePendingMap[compositeKey]) {
    if (typeof cacheCallback === 'function') {
      cacheCallback();
    }
    return cachePromisePendingMap[compositeKey];
  }

  registerCachePromiseIndex(normalizedType, normalizedKey, compositeKey);

  const task = Promise.resolve()
    .then(() => promiseCb())
    .then((res) => {
      cachePromiseCache.set(compositeKey, res, expirationTime);
      return res;
    })
    .finally(() => {
      delete cachePromisePendingMap[compositeKey];
    });

  cachePromisePendingMap[compositeKey] = task;
  return task;
}

/**
 * 将网络图片转换为Blob URL
 * @param {string} imageUrl - 网络图片URL
 * @param {Function} [progressCallback] - 可选进度回调函数
 * @returns {Promise<string>} - 返回解析为Blob URL的Promise
 */
export function convertImageToBlobUrl(imageUrl, progressCallback) {
  return new Promise((resolve, reject) => {
    // 验证输入URL
    if (!imageUrl || typeof imageUrl !== 'string') {
      return reject(new Error('无效的图片URL'));
    }

    try {
      // 验证URL格式
      new URL(imageUrl);
    } catch (e) {
      return reject(new Error('URL格式无效'));
    }

    const xhr = new XMLHttpRequest();
    xhr.open('GET', imageUrl, true);
    xhr.responseType = 'blob'; // 重要：指定响应类型为blob

    // 进度事件处理
    if (progressCallback && typeof progressCallback === 'function') {
      xhr.onprogress = function (event) {
        if (event.lengthComputable) {
          const percent = Math.round((event.loaded / event.total) * 100);
          progressCallback(percent);
        }
      };
    }

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        const blob = xhr.response;

        // 验证是否为图片
        if (!blob.type.startsWith('image/')) {
          return reject(new Error('获取的资源不是图片类型'));
        }

        // 创建Blob URL
        const blobUrl = URL.createObjectURL(blob);
        resolve(blobUrl);
      } else {
        reject(new Error(`图片加载失败，状态码: ${xhr.status}`));
      }
    };

    xhr.onerror = function () {
      reject(new Error('网络请求失败'));
    };

    xhr.ontimeout = function () {
      reject(new Error('请求超时'));
    };

    xhr.send();
  });
}
/**
 * 检查 slotRect 是否有效
 * slotRect 必须是长度大于 1 的数组，且不能包含 NaN 或 undefined
 * @param {*} slotRect - 要检查的 slotRect 值
 * @param {string} location - 标记位置，用于错误日志
 * @returns {boolean} 是否有效
 */
function validateSlotRect(slotRect, location) {
  // 检查是否为数组
  if (!Array.isArray(slotRect)) {
    logger.error(`[slotRect验证失败-${location}] slotRect不是数组:`, slotRect);
    return false;
  }

  // 检查数组长度
  if (slotRect.length <= 1) {
    logger.error(
      `[slotRect验证失败-${location}] slotRect数组长度必须大于1, 当前长度:${slotRect.length}, 值:`,
      slotRect
    );
    return false;
  }

  // 检查数组中是否有 NaN 或 undefined
  let hasInvalidValue = false;
  for (let i = 0; i < slotRect.length; i++) {
    if (typeof slotRect[i] === 'undefined' || isNaN(slotRect[i])) {
      hasInvalidValue = true;
      logger.error(
        `[slotRect验证失败-${location}] slotRect包含无效值, 索引${i}: ${slotRect[i]}, 完整值:`,
        slotRect
      );
      break;
    }
  }

  return !hasInvalidValue;
}

/**
 * 验证 socketInfo 及其 slotRect 是否有效
 * @param {Object|null|undefined} socketInfo - socketInfo 对象
 * @param {string} location - 标记位置，用于错误日志
 * @returns {boolean} 是否有效
 */
function validateSocketInfoSlotRect(socketInfo, location) {
  if (!socketInfo) {
    logger.error(`[socketInfo验证失败-${location}] socketInfo不存在`);
    return false;
  }

  if (!socketInfo.slotRect) {
    logger.error(
      `[socketInfo验证失败-${location}] socketInfo存在但slotRect不存在, socketInfo:`,
      socketInfo
    );
    return false;
  }

  return validateSlotRect(socketInfo.slotRect, location);
}

/**
 * 获取背景默认透明度，无透明底 SKU 固定返回不透明。
 *
 * @param {number} [opacityFactor] - 可选透明度系数，用于纯色色板自身透明度叠加
 * @returns {number} 背景透明度
 */
function getBackgroundDefaultOpacity(opacityFactor) {
  let template = Store.get('skuTemplate') || {};
  return getSkuBackgroundDefaultOpacity(template, opacityFactor);
}

/**
 * 判断当前是否为微信内置浏览器
 * @returns {boolean} true=微信内，false=非微信
 */
function isWeChat() {
  // 获取浏览器UA并转为小写
  const userAgent = navigator.userAgent.toLowerCase();
  // 微信UA固定包含 microMessenger 标识
  return /micromessenger/.test(userAgent);
}

function checkWeakNetwork() {
  // 检测浏览器是否支持
  if (!navigator?.connection) {
    console.log('浏览器不支持Network API，降级使用其他方案');
    return false;
  }

  const connection =
    navigator.connection ||
    navigator.mozConnection ||
    navigator.webkitConnection;

  // 定义弱网判断规则
  const weakNetworkTypes = ['slow-2g', '2g']; // 极慢/慢速网络
  const maxEffectiveMbps = 1; // 有效带宽 ≤ 1Mbps 判定为弱网

  const isWeak =
    weakNetworkTypes.includes(connection.effectiveType) ||
    connection.downlink <= maxEffectiveMbps;

  // 监听网络变化
  connection.addEventListener('change', () => {
    console.log('网络状态变更：', connection.effectiveType);
    checkWeakNetwork();
  });

  return isWeak;
}

export {
  Indicator,
  showLoading,
  hideLoading,
  Toast,
  api,
  qs,
  loadImage,
  setTitle,
  stopScroll,
  delay,
  ignoreMultiClick,
  ignoreRepeatedTrigger,
  base64ToFile,
  parseIntPrice,
  calcMaxSize,
  calcCenterSize,
  getSideLength,
  getAngleFromThreeSideLength,
  timeout,
  getImageInfo,
  useCompressImage,
  log,
  downloadFile,
  report,
  event,
  Store,
  action,
  checkImageRisk,
  getApp,
  confirmModal,
  fileToBase64,
  getImgFileSize,
  pollCheck,
  previewImage,
  limitConcurrency,
  createId,
  removeUnUseStorage,
  getPhotoSizeInfo,
  isOnlineImage,
  copyText,
  getImgErrorCode,
  repeatPromise,
  isPC,
  getBase64MimeType,
  convertCropInfo,
  fileToBlobUrl,
  getFileFromBlobUrl,
  revokeBlobUrl,
  errorHandler,
  getFailInfo,
  getFailInfoByError,
  failReasonMap,
  slog,
  errorToString,
  convertRawCameraImage,
  getDomDetail,
  saveImage,
  isPc,
  polyfillForPcTouches,
  isWebPSupportedWithImage,
  webpToJpg,
  isSupprtWebp,
  cardTypeList,
  pbTypeList,
  lifeTypeList,
  nameStickerTypeList,
  pldSkyTypeList,
  colorPaperTypeList,
  bajiTypeList,
  beidianTypeList,
  createLogFile,
  setClipBoard,
  getPhotoList,
  setPhotoList,
  hasPhotoListCache,
  getTempPhotoList,
  setTempPhotoList,
  uploadLogFile,
  lifePbTypeList,
  keyTypeList,
  isCustomSizeTypeList,
  supportDivideUploadList,
  retouchHeadTypeList,
  templateLayerTypeList,
  noTemplateLayerTypeList,
  crystalTypeList,
  frontBackLayer,
  layerTypeList,
  TextBottom,
  TextLeft,
  isSVGSupported,
  pasterTypeList,
  processExifData,
  removeRotatedImageExif,
  copyUrlParams,
  photoRollTypeList,
  deepCopy,
  toFixed,
  getStore,
  setStore,
  setCurrentOuterOiIdPhysicalMaskUrl,
  getCurrentOuterOiIdPhysicalMaskUrl,
  selectFile,
  rafThrottle,
  getImageDimensions,
  parseParams,
  blobUrlToFile,
  retryWithCheck,
  logTime,
  getImageType,
  getDouyinData,
  setDouyinData,
  loadJsSdk,
  finishSubmit,
  isDouyinApp,
  throttle,
  removeFileExif,
  compressImage,
  clearAllCookies,
  validateSlotRect,
  validateSocketInfoSlotRect,
  debugLog,
  constant,
  ROUTE_NAMES,
  getBackgroundDefaultOpacity,
  clearLogFile,
  clearPageDebugLog,
  copyPageDebugLog,
  isWeChat,
  checkWeakNetwork,
  detectImageIntegrity,
  repairImageIntegrity,
  downloadPageDebugLog,
  initPageDebugLogButton,
  recordPageDebugLog,
  debugGroupConsole as console
};
